import { Injectable, EventEmitter, ViewChild, TemplateRef, ElementRef } from '@angular/core';
// import { Observable } from 'rxjs/Rx';
import { Observable, from, BehaviorSubject, Subscription, interval } from 'rxjs';

import { HttpService } from './http.service';
import { LocalStorageService } from './local_storage.service';
import { WaitpromiseService } from './waitpromise.service';
import { BaseProvider } from '../providers/base';
import { HttpClient } from 'selenium-webdriver/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';
import { ConstanteEcorec } from '../../recylog/application/constante.ecorec';
import { listFonctionAdmin } from '../../recylog/application/paramFonctionAdmin';
import { Router } from '@angular/router';
import { Renderer2, RendererFactory2 } from '@angular/core';
import { listFonctionAdminKerlog } from '../../../app/recylog/application/paramFonctionAdminKerlog';
declare var Base64: any;
declare var $: any;
declare var JSPM: any;

@Injectable()
export class CommonService extends BaseProvider {
  popTemplate;
  popTemplateChorus;
  docTemplate;
  public msgError: Boolean = true;
  public error = '';
  public isLogin: Boolean = true;
  public slideMenu: Boolean = false;
  public idPiece;
  public user: any[] = [];
  public listeFiltre: any[] = [];
  public filtrePlanning: any[] = [];
  public filtreValidation: any[] = [];
  public filtreFact: any[] = [];
  public filtreBenne: any[] = [];
  public filtreFacture: any[] = [];
  public filtreBonachat: any[] = [];
  public filtreCompta: any[] = [];
  public filtreDevis: any[] = [];
  public filtreDevisDupliquerClient: any[] = [];
  public filtreRelanceFact: any[] = [];
  public filtrePaiement: any[] = [];
  public filtreContenant: any[] = [];
  public filtreRetourbon: any[] = [];
  public filtreRelancedevis: any[] = [];
  public filtreRDV: any[] = [];
  public filtreProforma: any[] = [];
  public filtreContrat: any[] = [];
  public listDoc: any[] = [];
  public filtreDetenteur: any[] = [];
  public filtreBonCommande: any[] = [];
  public filtreRegistreEntree: any[] = [];
  public filtreHistoriqueExpe: any[] = [];
  public filtreRegistreSortie: any[] = [];
  public filtreHistoBAP: any[] = [];
  public filtreFIP: any[] = [];
  public filtreCAP: any[] = [];
  public filtreUsager: any[] = [];
  
  filtrePrestation = [];
  filtrePrestationHisto = [];
  filtreChantier = [];
  filtreTournee = [];
  filtreDemandes = [];
  filtreBAK = [];
  filtreClient = [];
  filtreStockBac = [];
  filtreValidationBac = [];
  filtreEntrees = [];
  filtreSorties = [];
  filtreHistoRetourBon = [];
  filtreBAP = [];
  filtrePlanningRH = [];
  filtreHeures = [];
  filtreExpedition = [];
  filtreStockEcostock = [];
  filtreExpeditionEcodd = [];
  filtrePlanningEcogar = [];
  filtreParcentretienEcogar = [];
  filtreAppro = [];
  filtreValidationEcogar = [];
  filtreValidationEcogarHistoKm = [];
  filtreEcotri = [];
  filtreEcotriSortie = [];
  filtreEcodecVHU = [];
  periodeLst = [];
  elementPeriodePlanningEcobennes: any = {};
  public paramSociete = {};
  public showBon: Boolean = false;
  public client;
  public isEcoloc: Boolean = false;
  public isEcofact: Boolean = false;
  public gestionFIP: Boolean = false;
  public isFIPCET: Boolean = false;
  public isEcorh: Boolean = false;
  public isEcocrm: Boolean = false;
  public isEcogar: Boolean = false;
  public isFactBon: Boolean = false;
  public isFactBonImp: Boolean = false;
  public isFactBonCreat: Boolean = false;
  public isHistoPiece: Boolean = false;
  public isFacture: Boolean = false;
  public isBonachat: Boolean = false;
  public isCompta: Boolean = false;
  public isCaisse: Boolean = false;
  public isEcobennes: Boolean = false;
  public isDroitValideRetourEcobennes: Boolean = false;
  public isPlanningMoyenEcogar: Boolean = false;
  public isDroitCreationMouvementEcobennes: Boolean = false;
  public tarifArticle: Boolean = false;
  public isDroitGestionPersoEcoRH: Boolean = false;
  public isDroitGestionHeureEcoRH: Boolean = false;
  public isEcobac: Boolean = false;
  public isEcocontrat: Boolean = false;
  public isContratFact: Boolean = false;
  public isCreateContrat: Boolean = false;
  public isEditContrat: Boolean = false;
  public isPlanningBac: Boolean = false;
  public isImportCmd: Boolean = false;
  public isEcodec: Boolean = false;
  public isEcodd: Boolean = false;
  public isEcostock: Boolean = false;
  public isEcostockFact: Boolean = false;
  public isDroitGestionEcostock: Boolean = false;
  public isRappel: Boolean = false;
  public isPrestation: Boolean = false;
  public isRelance: Boolean = false;
  public isPaiement: Boolean = false;
  public isDragDrop: Boolean = false;
  public isLogoutEncours: Boolean = false;
  public isCreateAvoir: Boolean = false;
  public isMajRetroBon: Boolean = false;
  public isHistoBon: Boolean = false;
  public isDetenteur: Boolean = false;
  public isTournee: Boolean = false;
  public isGestionDemande: Boolean = false;
  public isBtnDupliquer: Boolean = false;
  public planningInUse: Boolean = false;
  public hideDetailCht: Boolean = false;
  public isloadEcoportail: Boolean = false;
  public reloadHeaderEcoportail: Boolean = false;
  public sauvegarderValeurs: Boolean = false;
  public isHisto: Boolean = false;
  public isBAK: Boolean = false;
  public isExportPaie: Boolean = false;
  public isLibradata: Boolean = false;
  public isEcodechet: Boolean = false;
  public isEcopol: Boolean = false;
  public isProspectHolding: Boolean = false;
  public isCreateClient: Boolean = false;
  public isModifClient: Boolean = false;
  public isCMchantier: Boolean = false;
  public isModuleEcoachat: Boolean = false;
  public isRDV: Boolean = false;
  public droitParam: any = {};
  public droitParamHolding: any = {};
  public filterTaillePlanprest: any = 'normal';
  public filterTaillePlanrdv: any = 'normal';
  public filterTaillePlanrh: any = 'normal';
  public filterTaillePlancont: any = 'normal';
  public intervalRappel;
  public listRepertoire = [];
  public listActualite = [];
  public listFilDicsussion = [];
  public objetNotify: any = {};
  public video;
  public dropdown;
  public listDropDown = [];
  public inputTypeDate = [];
  public urlRapport = [];
  public listeWidgetBlocLien = [];
  public isAppelPayfipUserAnonyme: Boolean = false;
  public isEcoPAV: Boolean = false;
  public isDeleteTournee: Boolean = false;
  public isCarteChauffeurs: Boolean = false;
  public isEcotri: Boolean = false;
  public isTri: Boolean = false;
  public isTriSortie: Boolean = false;
  public isDroitPlanningEcobac: Boolean = false;
  public isDroitValidationEcobac: Boolean = false;
  public isImportFichiersPesees: Boolean = false;
  public isDroitBonAFacturer: Boolean = false
  public isGestionFact: Boolean = false;
  public showTypeFile: Boolean = false;
  websocketPlaning;
  isEcorecOnline: Boolean = false;
  requetteEncours: Boolean = false;
  requetteAccesEncours: Boolean = false
  isRequestDetailArticle: Subscription = null;

  public isContenantInit: Boolean = false;
  public isRDBInit: Boolean = false;
  public isPlaningInit: Boolean = false;
  public isRedirectOpenDocImp: Boolean = false;


  public isHomeEcoportail: Boolean = false;

  EcoGED5: Boolean = false;
  EcoGED12: Boolean = false;
  EcoGED28: Boolean = false;
  RDVDecheterieDemande: Boolean = false;
  isLostFocusP1P2Ecobennes: Boolean = false;

  paramPaiement: any = {};
  public isTableauContainer: Boolean = false;

  websocketReminder;
  // $$
  dynamicFilterFacture: any = [];
  dynamicFilterBonachat: any = [];
  modalRef: BsModalRef;
  arrayModalRef: any = [];
  arrayModalAcompteRef: any = [];
  nbrNotification = 0;
  clefTypeDocPieceEcorec;
  typeDoc = '';
  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'confirmModal'
  };
  configlg = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-lg modalperso'
  };

  configlgDmd = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-lg modalperso dmdEcoGED'
  };

  configPaiement = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modalPaiement'
  };
  userInfo;
  listLog = [];
  lastLog: any = [];
  logModifEtendu = {};
  logChorus = {};
  numFactureChorus = '';
  selectedRapport: any = {};
  transformMenuParam: Boolean = false;
  isNotFirstLoad: Boolean = false;
  titreLog: any = '';

  /* constantes type format parametrable */
  public TYPE_FORMAT_PARAMETRABLE_DEVIS = 1;
  public TYPE_FORMAT_PARAMETRABLE_CAP = 30;
  public TYPE_FORMAT_PARAMETRABLE_BON_BENNES = 7;

  /* constantes type bon */
  public BON_LIVRAISON = 1;
  public BON_RECEPTION = 2;
  public BON_PRESTATION = 3;
  public BON_EXPEDITION = 4;
  public BON_ENLEVEMENT = 5;
  userDetail: any = {};
  public defaultViewPlanningBenne: any = {};
  public defaultViewPlanningEcoloc: any = {};
  public defaultViewPlanningEcogar: any = {};
  public defaultViewPlanningMoyensEcogar: any = {};
  public defaultViewPlanningBac: any = {};
  public defaultViewContenant: any = {};
  public defaultViewDemande: any = {};
  public defaultViewDetenteur: any = {};
  public defaultViewBAK: any = {};
  public defaultViewEcoRH: any = {};
  public defaultViewRetourbon: any = {};
  public defaultViewValidation: any = {};
  public defaultViewEcofact: any = {};
  public defaultViewEcodd: any = {};
  public defaultViewEcopol: any = {};
  public defaultViewEcostock: any = {};
  public defaultViewEcotri: any = {};
  public ficheClientPrixNegocies: any = {};
  defaultViewEcocrm: any = {};
  defaultViewEcocontrat: any = {};
  defaultViewRecylog: any = {};
  defaultViewTournee = {};
  public defaultViewValidationEcobac: any = {};
  openRechercheEcoportail: Boolean = false;
  reloadFil: Boolean = false;
  filtreEcoportail: any = {};
  ecoportailPage: any = {};
  treeDataDocsAlfresco: any = [];
  public treeFieldsDocsAlfresco: any = {};
  public folderSelectedAlfresco: any = {};
  activedModule: any = 0;
  visibleChamp: any = {};
  USER_CONNECTED: any = 0;
  menuClick: Boolean = false;
  clickMenu: any = {};
  isLoadingApp: Boolean = false;
  isFiche: Boolean = false;
  isRequestHoraireLoad: Boolean = false;
  Shibboleth: Boolean = false; // SSO
  tplApropos;
  objetApropos = {};
  delay;
  listAccesChampFicheParam: any = {};
  isTimeout: Boolean = false;
  indexAutoComplete = 1;
  doSomethingAfterCloseDoc: any = {};
  doSomethingAfterGetWarDeployer: any = {};
  doSomethingAfterCloseEchape: any = {};
  doSomethingAddLigneArtEcoloc: any = {};
  lastNavigate = "login";
  valeurAvantChagementPlanningEcobennes: any = {};

  firstCallLoadPlanning: any = {};

  // conservation tri ecofact
  ecofact_facturation_tri: any = [];
  ecoStock_gestStock_tri: any = {};
  ecofact_bon_achat_tri: any = [];
  ecofact_facture_tri: any = [];

  prixNegocieTrie: any = [];
  breakpoint = 4;
  codeExterneClient;
  logoutTerminer = false;
  listEmplacementContenant: any = [];
  listParamActive = []
  listTypePaie: any = [];
  extFichierImg = '.jpeg, .jpg, .png, .pdf, .tif, .bmp, .zip';
  extFichierImgEtTexte = '.jpeg, .jpg, .png, .pdf, .tif, .bmp, .odt, .ods, .odp, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .rtf, .zip';
  msgErreurExtensionFichier = 'Vous ne pouvez pas charger ce type de fichier.';
  indexNameAutocomplete = 0;
  parametrageEcran = {};

  spinnerNotShow: Boolean = false;

  afficherBtnDownloadAll: Boolean = false;
  subscription: Subscription;
  isRequestDetailClient: Subscription = null;
  isRequestDetailChantier: Subscription = null;
  isRequestListeContenant: Subscription = null;
  isRequestDetailBon: Subscription = null;
  isRequestDetailBonHisto: Subscription = null;
  isRequestDetailFact: Subscription = null;
  isRequestDetailBA: Subscription = null;
  DBGestionConnexionUser: Subscription = null;
  DBGetListCommande: Subscription = null;

  modalService;
  msgCommon;
  errorMsg;

  listMvtRdb: any = [];
  listFonctionAdmin: any = [];
  listFonctionAdminKerlog: any = [];
  fctAdminSelected: any = {};
  fctAdminKerlogSelected: any = {};

  listeSociete: any = [];
  isHolding: Boolean = false;
  navigatedInternally: Boolean = false;
  lemonLDAPPortail: Boolean = false;
  lemonLDAPObjet: any = {};
  dropdownObject: any = {};
  isApproEcocontrat: Boolean = false;
  isExpedEcocontrat: Boolean = false;
  isFacturationEcocontrat: Boolean = false;
  private majLieuSource = new BehaviorSubject<boolean>(false);
  majLieu$ = this.majLieuSource.asObservable();
  constructor(protected http: HttpService,
    public local: LocalStorageService,
    public router: Router, public waitProm: WaitpromiseService) {
    super(http, '', local, waitProm);
    this.isLogin = this.local.getObject('userInfo') ? true : false;
    this.user = this.local.getObject('userInfo') || [];
    this.userDetail = this.local.getObject('userDetail') || {};
    this.USER_CONNECTED = this.local.get('userConnected');
    const isholding = this.local.get('isHolding');
    this.isEcorecOnline = window.location.href.includes('www.ecorec-online.fr') || window.location.href.includes(':4201') ? true : false;
    environment.old_api_url = environment.base_url;
  
    if (isholding) {
      const societe = this.local.getObject('societeHolding');
      this.changeUrl(societe);
      environment.api_dmd = this.intercept(environment.api_dmd);
    } else {
      environment.api_dmd = this.intercept(environment.api_dmd);
    }
    const ctrl = this;
    this.doSomethingAfterCloseDoc = new BehaviorSubject<any>(null)
    this.doSomethingAfterGetWarDeployer = new BehaviorSubject<any>(null)
    this.doSomethingAfterCloseEchape = new BehaviorSubject<any>(null)
    this.firstCallLoadPlanning = new BehaviorSubject<any>(null)
    this.doSomethingAddLigneArtEcoloc = new BehaviorSubject<any>(null)
    window.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        // console.log('key down escape', e)
        const randomString = Math.random().toString(36).slice(-6);
        ctrl.doSomethingAfterCloseEchape.next(randomString)
      }
    });

    this.listFonctionAdmin = [...listFonctionAdmin];
    this.listFonctionAdminKerlog = [...listFonctionAdminKerlog];
    

    // JSPM.JSPrintManager.auto_reconnect = true;
    // JSPM.JSPrintManager.start();
    // JSPM.JSPrintManager.WS.onStatusChanged = () => {
    //   if (this.jspmWSStatus()) {
    //     // get client installed printers
    //     JSPM.JSPrintManager.getPrinters().then((myPrinters: string[]) => {
    //       const printers = myPrinters;
    //       console.log(printers);
    //     });
    //   }
    // };

  }

  jspmWSStatus() {
    if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
      return true;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Closed) {
      alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
      return false;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Blocked) {
      alert('JSPM has blocked this website!');
      return false;
    }
  }

  doPrintPDF(url) {
    if (this.jspmWSStatus()) {
      const cpj = new JSPM.ClientPrintJob();
      cpj.clientPrinter = new JSPM.DefaultPrinter();
      const my_file = new JSPM.PrintFilePDF(url, JSPM.FileSourceType.URL, 'MyFile.pdf', 1);
      cpj.files.push(my_file);
      cpj.sendToClient();
    }
  }

  bak: any = {};

  getDetailBak(adresseAutoBAK, clefBAK) {
    this.bak = {};
    if (adresseAutoBAK && clefBAK) {
      const param = {
        'servlet': 'DBGestionBAKAngular',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 9
          },
          'CLEF_USER': {
            'typeParam': 'int',
            'valeur': this.user[0]
          },
          'CLEF_BAK': {
            'typeParam': 'int',
            'valeur': clefBAK
          },
          'CLEF_SITE': {
            'typeParam': 'int',
            'valeur': (this.user[2] || 0)
          }
        }
      }

      return this.post('', { param: param }).then(datas => {
        if (this.verifySession(datas)) {
          this.bak = datas.data || {};
        }
      });
    } else {
      this.bak = {};
      return Promise.resolve()
    }
  }

  initValeurLocalStorage(isHome?) {
    this.isLogin = this.local.getObject('userInfo') ? true : false;
    this.user = this.local.getObject('userInfo') || [];
    this.userDetail = this.local.getObject('userDetail') || {};
    this.USER_CONNECTED = this.local.get('userConnected');
  }

  initTimer() {
    const source = interval(300000); // tous les 5 mn
    this.subscription = source.subscribe(val => {
      if (this.DBGestionConnexionUser) {
        this.DBGestionConnexionUser.unsubscribe();
      }
      this.userConnectedCall();
    });
  }

  public removeConnection() {
    if (!environment.moduleEcoportailOnly && !this.isLogoutEncours) {
      this.isLogoutEncours = true;
      if (this.isRequestDetailArticle) {
        this.isRequestDetailArticle.unsubscribe();
      }

      this.local.remove('userInfo');
      this.local.remove('paramSociete');
      this.local.remove('userDetail');
      this.local.remove('globalParam');
      this.local.remove('listeSite');
      // localStorage.clear();
      this.subscription.unsubscribe();
      if (this.isRequestDetailBon) {
        this.isRequestDetailBon.unsubscribe();
      }
      if (this.isRequestDetailBonHisto) {
        this.isRequestDetailBonHisto.unsubscribe();
      }
      if (this.isRequestDetailFact) {
        this.isRequestDetailFact.unsubscribe();
      }
      if (this.isRequestDetailBA) {
        this.isRequestDetailBA.unsubscribe();
      }
      if (this.DBGestionConnexionUser) {
        this.DBGestionConnexionUser.unsubscribe();
      }
      if (this.isRequestDetailClient) { this.isRequestDetailClient.unsubscribe(); }
      if (this.isRequestDetailChantier) { this.isRequestDetailChantier.unsubscribe(); }
      if (this.isRequestListeContenant) { this.isRequestListeContenant.unsubscribe(); }
      if (this.DBGetListCommande) {
        this.DBGetListCommande.unsubscribe();
      }

      this.nbrNotification = 0;
      const holding = this.local.get('isHolding');
      if (this.isDragDrop && this.planningInUse) {
        this.removeAccesPlanning().then(data => {
          this.logout().then(logout => {
            this.userConnectedLogout();
            this.local.removeAll();
            this.hasMsgError = false;
            environment.base_url = environment.old_api_url;
            this.isLogoutEncours = false;
            this.getLogoAndColor();
          });
        });
        this.planningInUse = false;
      } else {
        this.logout().then(logout => {
          this.userConnectedLogout();
          this.local.removeAll();
          environment.base_url = environment.old_api_url;
          this.isLogoutEncours = false;
          this.hasMsgError = false;
          this.getLogoAndColor();
        });
      }
      if (this.websocketReminder) {
        this.websocketReminder.close();
      }
      this.changeFlavicon();
      this.reloadValeurParDefaut();
      clearInterval(this.intervalRappel);
      setTimeout(function () {
        $('#login-input').focus();
      }, 500);
    }
  }

  reloadValeurParDefaut() {
    this.isLogin = false;
    this.dropdownObject = {};
    this.isLoadingApp = false;
    this.navigatedInternally = false;
    this.gestionFIP = false;
    this.isFIPCET = false;
    // this.userDetail = {};
    this.menuClick = false;
    this.isFiche = false;
    this.isLostFocusP1P2Ecobennes = false;
    this.transformMenuParam = false;
    this.clickMenu = {};
    this.filterTaillePlanprest = 'normal';
    this.filterTaillePlanrdv = 'normal';
    this.filterTaillePlanrh = 'normal';
    this.filterTaillePlancont = 'normal';
    this.listeFiltre = [];
    this.filtrePlanning = [];
    this.filtreValidation = [];
    this.filtreFact = [];
    this.filtreBenne = [];
    this.filtreFacture = [];
    this.filtreBonachat = [];
    this.filtreCompta = [];
    this.filtreDevis = [];
    this.filtreDevisDupliquerClient = [];
    this.filtreRelanceFact = [];
    this.filtreRelancedevis = [];
    this.filtrePaiement = [];
    this.filtreContenant = [];
    this.filtreRDV = [];
    this.filtreDetenteur = [];
    this.filtreBonCommande = [];
    this.filtreRegistreEntree = [];
    this.filtreHistoriqueExpe = [];
    this.filtreRegistreSortie = [];
    this.filtreHistoBAP = [];
    this.filtreFIP = [];
    this.filtreCAP = [];
    this.filtreProforma = [];
    this.filtreContrat = [];
    this.filtrePrestation = [];
    this.filtrePrestationHisto = [];
    this.filtreChantier = [];
    this.dynamicFilterFacture = [];
    this.dynamicFilterBonachat = [];
    this.listRepertoire = [];
    this.listActualite = [];
    this.listFilDicsussion = [];
    this.filtreTournee = [];
    this.filtreDemandes = [];
    this.filtreBAK = [];
    this.filtreClient = [];
    this.filtreStockBac = [];
    this.filtreValidationBac = [];
    this.filtreEntrees = [];
    this.filtreSorties = [];
    this.filtreBAP = [];
    this.filtreHistoRetourBon = [];
    this.filtrePlanningRH = [];
    this.filtreHeures = [];
    this.filtreExpedition = [];
    this.filtreAppro = [];
    this.filtreExpeditionEcodd = [];
    this.filtreValidationEcogar = [];
    this.filtreValidationEcogarHistoKm = [];
    this.filtreEcotri = [];
    this.filtreEcotriSortie = [];
    this.filtreEcodecVHU = [];
    this.filtrePlanningEcogar = [];
    this.filtreParcentretienEcogar = [];
    this.filtreEcoportail = {};
    this.objetNotify = {};
    this.droitParam = {};
    this.droitParamHolding = {};
    this.defaultViewPlanningBenne = {};
    this.defaultViewPlanningEcoloc = {};
    this.defaultViewPlanningEcogar = {};
    this.defaultViewPlanningMoyensEcogar = {};
    this.defaultViewContenant = {};
    this.defaultViewDemande = {};
    this.defaultViewRetourbon = {};
    this.defaultViewValidationEcobac = {};
    this.defaultViewValidation = {};
    this.defaultViewEcofact = {};
    this.defaultViewEcodd = {};
    this.defaultViewEcostock = {};
    this.defaultViewEcotri = {};
    this.defaultViewEcocrm = {};
    this.defaultViewEcocontrat = {};
    this.defaultViewRecylog = {};
    this.defaultViewTournee = {};
    this.defaultViewDemande = {};
    this.defaultViewDetenteur = {}
    this.defaultViewBAK = {};
    this.defaultViewEcoRH = {};
    this.defaultViewEcopol = {};
    this.paramPaiement = {};
    this.listAccesChampFicheParam = {};
    this.listEmplacementContenant = [];
    this.listParamActive = [];
    this.parametrageEcran = {};
    this.ficheClientPrixNegocies = {};
    this.listMvtRdb = [];
    this.valeurAvantChagementPlanningEcobennes = null;
    this.elementPeriodePlanningEcobennes = {};

  }

  logoutEcoportail(isLogin?, notSup?) {
    if (!this.logoutTerminer) {
      this.dropdownObject = {};
      this.logoutTerminer = true;
      this.nbrNotification = 0;
      this.listRepertoire = [];
      this.listActualite = [];
      this.selectedRapport = {};
      this.listFilDicsussion = [];
      this.urlRapport = [];
      this.listeWidgetBlocLien = [];
      this.objetNotify = {};
      this.droitParam = {};
      this.droitParamHolding = {};
      this.filtreEcoportail = {};
      this.filtreChantier = [];
      this.reloadFil = false;
      this.listRepertoire = []
      this.treeFieldsDocsAlfresco = {};
      this.treeDataDocsAlfresco = []
      this.folderSelectedAlfresco = {};
      this.local.remove('clientLogin');
      this.local.remove('customerEcoPortail');
      // localStorage.clear();
      this.local.removeAll();
      if (isLogin) {
        this.logoutTerminer = false;
        console.log('lougout depuis login');
      } else {
        if (!notSup) {
          this.codeExterneClient = '';
        }
        this.getEcoportail('user/logout').then(data => {
          if (this.lemonLDAPObjet && this.lemonLDAPObjet.id && this.lemonLDAPObjet.urlLogout) {
            window.location.replace(this.lemonLDAPObjet.urlLogout);
          }
          this.logoutTerminer = false;
        }).catch(er => {
          this.logoutTerminer = false;
        });
      }
    }
  }

  userConnectedLogout() {
    if (!this.userDetail['adminKerlog']) {
      const id = this.user[0] || '';
      const USER_CONNECTED = this.USER_CONNECTED || 0;
      const param = {
        'servlet': 'DBGestionConnexionUser',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 3
          },
          'USER': {
            'typeParam': 'int',
            'valeur': id
          },
          'CLEF_USER_CONNECTED': {
            'typeParam': 'int',
            'valeur': USER_CONNECTED
          }
        }
      };

      if (id !== '') {
        return this.post('', { param: param }).then(datas => {
          this.USER_CONNECTED = 0;
        });
      }
    }
  }

  userConnectedLogin(id) {
    const param = {
      'servlet': 'DBGestionConnexionUser',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'USER': {
          'typeParam': 'int',
          'valeur': id
        }
      }
    };

    if (id && !this.userDetail['adminKerlog']) {
      return this.post('', { param: param }, false, true).then(datas => {
        this.local.set('userConnected', datas.data);
        this.USER_CONNECTED = datas.data || 0;
        return datas;
      });
    } else {
      return Promise.resolve();
    }
  }


  async userConnectedGetMessage(id) {
    const param = {
      'servlet': 'DBGestionConnexionUser',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'USER': {
          'typeParam': 'int',
          'valeur': id
        }
      }
    };
    this.initTimer();
    if (id && !this.userDetail['adminKerlog']) {
      return this.post('', { param: param }, false, true).then(datas => {
        return datas;
      });
    } else {
      return Promise.resolve();
    }
  }

  changeDate(event, val, id?) {
    const isdate = moment(val);
    if (isdate.isValid()) {
      if (id) {
        this.focusElement(id);
      } else {
        if (event.srcElement && event.srcElement.nextElementSibling) {
          event.srcElement.nextElementSibling.focus();
        }
      }
    } else {
      if (val && typeof val === 'string') {
        const type = val.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/) ? true : false;
        if (type) {
          if (id) {
            this.focusElement(id);
          } else {
            if (event.srcElement && event.srcElement.nextElementSibling) {
              event.srcElement.nextElementSibling.focus();
            }
          }
        }
      } else {
        console.log('date not valide');
      }
    }
  }

  isDate(val) {
    if (val && typeof val === 'string') {
      return val.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/) ? val : 'Date invalide';
    } else {
      if (typeof val === 'object') {
        return moment(val).format('DD/MM/YYYY');
      } else {
        return false;
      }
    }
  }

  isDateElem(val) {

    if (typeof val === 'object') {
      return moment(val).isValid() ? true : false;
    } else {
      return false;
    }
  }

  LightenDarkenColor(hex, lum) {
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = -0.3 || 0;

    // convert to decimal and change luminosity
    let rgb = '#', c, i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i * 2, 2), 16);
      c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
      rgb += ('00' + c).substr(c.length);
    }

    return rgb;
  }

  parseDate(date, heure?, min?) {
    const type = typeof date;
    if (date && type === 'string') {
      const parts = date.split('/');
      if (heure) {
        return new Date(parts[2], parts[1] - 1, parts[0], heure, min || 0);
      } else {
        return new Date(parts[2], parts[1] - 1, parts[0]);
      }
    }
    if (type === 'object') {
      return date;
    }
  }

  getwidth() {
    if ($('.search ')[0]) {
      return ($('.search ')[0].clientWidth) > 267 ? 279 : ($('.search ')[0].clientWidth);
    }
  }

  testDate(str) {
    const t = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (t === null) {
      return;
    }
    const d = +t[1], m = +t[2], y = +t[3];
    if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {
      return true;
    }
    return false;
  }

  convertHeure(hoursArg, separateur?) {
    let hours = '' + (hoursArg || '');
    const parts = hours.split(separateur ? separateur : ':');
    if (parts && parts.length == 2) {
      return parseFloat(parts[0]) + (parseFloat(parts[1]) / 60);
    }

    return hoursArg;
  }

  convertStringToHeure(heureString, separateur?) {// EcoLM
    heureString = heureString || '';
    separateur = separateur || '.';
    if (heureString !== '') {
      console.log(heureString, String(heureString), String(heureString).split(separateur));
      const parts = String(heureString).split(separateur);
      const heure = parseFloat(parts[0]);
      const min = parts[1] ? parseFloat('0.' + parts[1]) * 60 : 0;
      return moment(new Date().setHours(heure, min)).format('HH:mm');
    } else {
      return moment(new Date().setHours(0, 0)).format('HH:mm')
    }
  }

  verifyHour(str) {
    const value = str.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/);
    if (value === null) {
      return false;
    } else {
      return true;
    }
  }

  focusElement(element, timer?) {


    setTimeout(() => {
      if (element && element.startsWith('.')) {
        const el = document.querySelector(`${element}`);
        if (el) {
          (el as HTMLElement).focus();
        }
      } else if (element && element.startsWith('#')) {
        const result = element.replace(/^#/, "");
        const el = document.getElementById(result);
        if (el) {
          (el as HTMLElement).focus();
        }
      } else {
        $(element).focus();
      }
    }, timer || 0);


    // setTimeout(() => {
    //   $(element).focus();
    // }, timer ? timer : 500)
  }

  focusElementTimeout(element, timer?) {
    setTimeout(() => {
      $(element).focus();
    }, timer ? timer : 500)
  }

  clickElement(element, timer?) {
    // setTimeout(() => {
    //   $(element).click();
    // }, timer ? timer : 500)

    setTimeout(() => {
      if (element && element.startsWith('.')) {
        const el = document.querySelector(`${element}`);
        if (el) {
          (el as HTMLElement).click();
        }
      } else if (element && element.startsWith('#')) {
        const result = element.replace(/^#/, "");
        const el = document.getElementById(result);
        if (el) {
          (el as HTMLElement).click();
        }
      } else {
        $(element).click();
      }
    }, timer || 0);

  }

  focusNext(elt) {
    const list = $(elt).find('input');
    let index = 0;
    $(elt).find('input').each(function (elem) {
      if ($(this).is(':focus')) {
        index = elem;
      }
    });
    // $(list[index + 1]).focus();
    if ($(list[index + 1])[0] && $(list[index + 1])[0].id !== 'autocomplete') {
      const originalValue = $(list[index + 1]).val();
      $(list[index + 1]).val('');
      $(list[index + 1]).blur().focus().val(originalValue);
    } else {
      $(list[index + 1]).focus();
    }
  }

  focusNext2ms(elt) {
    setTimeout(() => {
      this.focusNext(elt)
    }, 2)
  }

  setFocuscalendar(event) {
    if (event.keyCode === 40 && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
    }
  }

  removeAccesPlanning() {
    const user = this.user; // this.local.getObject('userInfo');
    if (user && user[0] && environment.moduleEcobennes && !this.userDetail['adminKerlog']) {
      const param = {
        'servlet': 'DBLibereAccesPlanning',
        'module': 'Ecobennes',
        'type': 'map',
        'compression': 'false',
        'data': {
          'ID_USER': '' + (this.user[0] || 0),
          'ID_SITE': '' + (this.user[2] || 0)
        }
      };

      if (this.isEcorecOnline && this.websocketPlaning && this.websocketPlaning.readyState !== WebSocket.CLOSED) {
        this.closeWebSocketPlanning();
        return Promise.resolve();
      } else {
        this.requetteEncours = true;
        return this.post('', { param: param }).then(datas => {
          this.requetteEncours = false;
          return datas;
        });
      }
    } else {
      return Promise.resolve();
    }
  }

  diffDate(date1, date2) {
    const msecPerMinute = 1000 * 60;
    const msecPerHour = msecPerMinute * 60;
    const interval = date1.getTime() - date2.getTime();

    const minutes = Math.floor(interval / msecPerMinute);

    return Math.floor(interval / msecPerMinute);
  }

  dateDiff(date1, date2) {
    const diff = {};                         // Initialisation du retour
    let tmp = date2 - date1;

    tmp = Math.floor(tmp / 1000);             // Nombre de secondes entre les 2 dates
    diff['sec'] = tmp % 60;                    // Extraction du nombre de secondes

    tmp = Math.floor((tmp - diff['sec']) / 60);    // Nombre de minutes (partie entière)
    diff['min'] = tmp % 60;                    // Extraction du nombre de minutes

    tmp = Math.floor((tmp - diff['min']) / 60);    // Nombre d'heures (entières)
    diff['hour'] = tmp % 24;                   // Extraction du nombre d'heures

    tmp = Math.floor((tmp - diff['hour']) / 24);   // Nombre de jours restants
    diff['day'] = tmp;
    return diff;
  }

  parseDatefr(date, format) {
    const normalized = date.replace(/[^a-zA-Z0-9]/g, '-');
    const normalizedFormat = format.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');
    const formatItems = normalizedFormat.split('-');
    const dateItems = normalized.split('-');

    const monthIndex = formatItems.indexOf('mm');
    const dayIndex = formatItems.indexOf('dd');
    const yearIndex = formatItems.indexOf('yyyy');
    const hourIndex = formatItems.indexOf('hh');
    const minutesIndex = formatItems.indexOf('ii');
    const secondsIndex = formatItems.indexOf('ss');

    const today = new Date();

    const year = yearIndex > -1 ? dateItems[yearIndex] : today.getFullYear();
    const month = monthIndex > -1 ? dateItems[monthIndex] - 1 : today.getMonth() - 1;
    const day = dayIndex > -1 ? dateItems[dayIndex] : today.getDate();

    const hour = hourIndex > -1 ? dateItems[hourIndex] : today.getHours();
    const minute = minutesIndex > -1 ? dateItems[minutesIndex] : today.getMinutes();
    const second = secondsIndex > -1 ? dateItems[secondsIndex] : today.getSeconds();

    return new Date(year, month, day, hour, minute, second);
  }

  verifySession(datas) {
    if (datas.data !== null || datas.data) {
      return datas;
    } else {
      if (datas.message) {
        if (datas.message.includes('Utilisateur non authentifié')) {
          this.isTimeout = true;
          this.removeConnection();
          return false;
        } else {
          return datas;
        }
      }
    }
  }

  checkSessions() {
    const user = this.local.getObject('userDetail');
    if (user) {
      return this.checkSession(user.login).then(data => {
        if (!data) {
          this.removeConnection();
        } else {
          this.checkDroit();
          this.USER_CONNECTED = this.local.get('userConnected');
          this.changeFlavicon();
          if (this.DBGestionConnexionUser) {
            this.DBGestionConnexionUser.unsubscribe();
          }
          this.userConnectedCall();
        }
        return data;
      });
    } else {
      return Promise.resolve();
    }
  }

  isHasCompteConnected(param) {
    return this.checkSessionOpenId('/valid/token/', param);
  }

  hasMsgError = false;

  userConnectedCall() {
    const id = this.user[0] || 0;
    const USER_CONNECTED = this.USER_CONNECTED || 0;
    // console.log('appel tout les 5mn')
    const param = {
      'servlet': 'DBGestionConnexionUser',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'USER': {
          'typeParam': 'int',
          'valeur': id
        },
        'CLEF_USER_CONNECTED': {
          'typeParam': 'int',
          'valeur': USER_CONNECTED
        }
      }
    };
    if (id !== '' && !this.userDetail['adminKerlog']) {
      this.DBGestionConnexionUser = this.postSub('', { param: param }, false, true).subscribe(datas => {
        if (datas && datas.message && datas.message !== '' && !this.hasMsgError) {
          this.hasMsgError = true;
          this.DBGestionConnexionUser = null;
          this.errorMsg = datas.message;
          this.openModal(this.modalService, this.msgCommon);
          this.removeConnection();
        }
      }, (err) => {
        this.DBGestionConnexionUser = null;
      })
    }
  }

  DBGestionDemandeEcoGED(id) {
    const param = {
      'servlet': 'DBGestionDemandeEcoGED',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 8
        },
        'CLEFPARAM': {
          'typeParam': 'int',
          'valeur': id
        },
      }
    };

    return this.post('', { param: param });
  }

  DBGestionDemandeEcoGED5() {
    return this.DBGestionDemandeEcoGED(5).then(datas => {
      this.EcoGED5 = datas.data ? true : false;
    });
  }

  DBGestionDemandeEcoGED12() {
    return this.DBGestionDemandeEcoGED(12).then(datas => {
      this.EcoGED12 = datas.data ? true : false;
    });
  }

  DBGestionDemandeEcoGED28() {
    return this.DBGestionDemandeEcoGED(28).then(datas => {
      this.EcoGED28 = datas.data ? true : false;
    });
  }

  DBGestionDemandeEcoGED27() {
    return this.DBGestionDemandeEcoGED(27).then(datas => {
      this.RDVDecheterieDemande = datas.data ? true : false;
    });
  }

  lastPrestation() {
    if ($('.fc-rows').height() < ($(window).height() - 140)) {
      const heigth = $('tr[data-resource-id]:last-child td div').height() + (($(window).height() - 142) - $('.fc-rows').height());
      const ele = $('tr[data-resource-id]:last-child > td > div');
      if (ele[0]) {
        ele[0].style.height = heigth + 'px';
      }
      if (ele[1]) {
        ele[1].style.height = heigth + 'px';
      }
    }
  }

  forceDown(url) {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    url = this.intercept(url);

    const filename = url.substring(url.lastIndexOf('/') + 1);
    if (msie > 0) { // If Internet Explorer, return version number
      console.log('IE')
      const _window = window.open(url, '_blank');
      _window.document.close();
      _window.document.execCommand('SaveAs', true, filename || url)
      _window.close();
    } else {
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        // delete a;
        a.remove();
      };
      xhr.open('GET', url);
      xhr.send();
    }
  }

  openBase64(url, filename) {

    const win = window.open('', '_blank');
    let html = '';

    html += '<html>';
    html += '<body style="margin:0!important; overflow: hidden; width: 100%; height: 100%;">';
    html += '<iframe width="100%" height="100%" src="' + url + '" > </iframe>';
    html += '</body>';
    html += '</html>';

    setTimeout(() => {
      win.document.write(html);
    }, 0);

  }

  openBase64Content(base64Content, filename) {
    const win = window.open('', '_blank');
    let html = '';
    const mimetype = this.getMIMETypeByFileName(filename);
    // console.log('mimetype=' + mimetype);

    html += '<html>';
    html += '<body style="margin:0!important; overflow: hidden; width: 100%; height: 100%;">';
    html += '<iframe width="100%" height="100%" src="data:' + mimetype + ';base64,' + base64Content + '" > </iframe>';
    html += '</body>';
    html += '</html>';

    setTimeout(() => {
      win.document.write(html);
    }, 0);
  }

  openFile(url, notintercept?, isExport?) {
    const anchor = document.createElement('a');
    // const newTab =  window.open();
    const paramSociete = this.local.getObject('paramSociete') || {};
    url = notintercept ? url : this.intercept(url, isExport);
    anchor.href = url;
    anchor.onclick =
      function () {
        window.open(url, '_blank');
        return false;
      };

    document.body.appendChild(anchor);
    anchor.click();
  }

  openMultipleFile(urlList) {
    const ctrl = this;
    urlList.forEach((url, index) => {
      // url = this.intercept(url);
      ctrl.openFile(url);
    });
  }

  changeUrl(societe) {
    let base_url = document.getElementsByTagName('base')[0].href;
    base_url = this.RemoveLastDirectoryPartOf(this.RemoveLastDirectoryPartOf(base_url));
    const urldmd = '/EcorecServerAngular/rest/portail';
    if (societe) {

      const url = window.location;
      const protocol = url.protocol;
      const lastChar = (societe.ipSociete || '').substr(societe.ipSociete.length - 1);
      if (lastChar === '/') {
        societe.ipSociete = societe.ipSociete.substring(0, societe.ipSociete.length - 1);
      }

      if (!(/(http(s?)):\/\//i).test(societe.ipSociete)) {
        environment.base_url = `${protocol}//${societe.ipSociete}`;
      } else {
        if (environment.production) {
          environment.base_url = `${societe.ipSociete}`;
        } else {
          environment.base_url = `${societe.ipSociete}`;
          environment.base_url = environment.base_url.replace('https://www.ecorec-online.fr', 'http://localhost:4200')
        }
      }

      environment.image_url = `/EcorecServerAngular/images/`;
      environment.api_dmd = `${environment.base_url}${urldmd}`;

    } else {
      if (environment.production) {
        environment.base_url = base_url;
        environment.image_url = `${environment.base_url}/EcorecServerAngular/images/`;
        environment.api_dmd = `${environment.base_url}${urldmd}`;
      } else {
        environment.base_url = environment.base_url || '';
        environment.image_url = `${environment.base_url}/EcorecServerAngular/images/`;
        environment.api_dmd = `${environment.base_url}${urldmd}`;
      }
    }

    console.log(environment.base_url);
  }

  parseUrlHolding(ipSociete) {
    let base_url = '';
    const url = window.location;
    const protocol = url.protocol;
    const lastChar = (ipSociete || '').substr(ipSociete.length - 1);
    if (lastChar === '/') {
      ipSociete = ipSociete.substring(0, ipSociete.length - 1);
    }

    if (!(/(http(s?)):\/\//i).test(ipSociete)) {
      base_url = `${protocol}//${ipSociete}`;
    } else {
      base_url = `${ipSociete}`;
    }
    return base_url;
  }

  RemoveLastDirectoryPartOf = function (the_url) {
    const the_arr = the_url.split('/');
    the_arr.pop();
    return (the_arr.join('/'));
  }

  intercept(requrl?, isExport?) {
    requrl = requrl || '';
    let base_url = '';
    if (requrl.startsWith('/') || !requrl.includes('http')) {
      const isHolding = this.local.get('isHolding');
      base_url = environment.base_url;

      if (isHolding && isExport) {
        base_url = environment.old_api_url;
      }

      const RemoveLastDirectoryPartOf = function (the_url) {
        const the_arr = the_url.split('/');
        the_arr.pop();
        return (the_arr.join('/'));
      }
      if (!isHolding) {
        if (environment.production) {
          base_url = document.getElementsByTagName('base')[0].href;
          base_url = RemoveLastDirectoryPartOf(RemoveLastDirectoryPartOf(base_url));
        }
      }

      if (!requrl.startsWith('/')) {
        base_url = base_url + '/';
      }
      // console.log('base url', base_url, requrl);
    }
    return `${base_url}${requrl}`;
  }

  interceptHolding(requrl?) {
    requrl = requrl || '';
    let base_url = '';
    if (requrl.startsWith('/') || !requrl.includes('http')) {
      const isHolding = this.local.get('isHolding');
      base_url = environment.old_api_url;

      const RemoveLastDirectoryPartOf = function (the_url) {
        const the_arr = the_url.split('/');
        the_arr.pop();
        return (the_arr.join('/'));
      }

      if (environment.production) {
        base_url = document.getElementsByTagName('base')[0].href;
        base_url = RemoveLastDirectoryPartOf(RemoveLastDirectoryPartOf(base_url));
      }


      if (!requrl.startsWith('/')) {
        base_url = base_url + '/';
      }
      // console.log('base url', base_url, requrl);
    }
    return `${base_url}${requrl}`;
  }

  getType(type, id?) {
    let value, tab;
    const liste = [];
    switch (type) {
      case 'typetarif':
        const datas = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[67] : [];
        datas.forEach(elt => {
          if (elt.id === parseInt(id, 10)) {
            value = elt.libelleObjetEntite;
          }
        });
        break;
      case 'typeimpression':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[57] : [];
        break;
      case 'typefiliere':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[23] : [];
        break;
      case 'typeCivilite':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[30] : [];
        break;
      case 'typePays':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[39] : [];
        break;
      case 'typeActivite':
        tab = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[21] : [];
        if (tab) {
          for (const i in tab[0]) {
            if (tab[1].length && tab[0].length) {
              liste.push({ id: parseInt(tab[1][i], 10), libelle: tab[0][i] });
            }
          }
          value = liste;
        }
        break;
      case 'typeCom':
        tab = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[22] : [];
        if (tab) {
          for (const i in tab[0]) {
            if (tab[1].length && tab[0].length) {
              liste.push({ id: parseInt(tab[1][i], 10), libelle: tab[0][i] });
            }
          }
          value = liste;
        }
        break;
      case 'typeClient':
        tab = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[5] : [];
        if (tab) {
          for (const i in tab[0]) {
            if (tab[1].length && tab[0].length) {
              liste.push({ id: parseInt(tab[1][i], 10), libelle: tab[0][i] });
            }
          }
          value = liste;
        }
        break;
      case 'typeModepaie':
        tab = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[4] : [];
        if (tab) {
          for (const i in tab[0]) {
            if (tab[1].length && tab[0].length) {
              liste.push({ id: parseInt(tab[1][i], 10), libelle: tab[0][i] });
            }
          }
          value = liste || [];
        }
        break;
      case 'typeQteDASRI':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[68] : [];
        break;
      case 'typeSite':
        tab = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[0] : [];
        if (tab) {
          for (const i in tab[0]) {
            if (tab[1].length && tab[0].length) {
              liste.push({ id: parseInt(tab[1][i], 10), libelle: tab[0][i] });
            }
          }
          value = liste;
        }
        break;
      case 'typeFormspec':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[37] : [];
        break;
      case 'typeFlux':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[76] : [];
        break;
      case 'typeChampsupp':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[47] : [];
        break;
      case 'typezone':
        tab = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[6] : [];
        if (tab) {
          for (const i in tab[0]) {
            if (tab[1].length && tab[0].length) {
              liste.push({ id: parseInt(tab[1][i], 10), libelle: tab[0][i] });
            }
          }
          value = liste;
        }
        break;
      case 'listMotifCreationDevis':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[81] : [];
        break;
      case 'listeTypesFormatParametrable':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[48] : [];
        break;
      case 'listOperationSupp':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[26] : [];
        break;
      case 'listOperationSuppBennePlace':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[27] : [];
        break;
      case 'listOperationNonSupp':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[31] : [];
        break;
      case 'listUnite':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[9] : [];
        value[0] = value[0] || [];
        value[1] = value[1] || [];
        break;
      case 'listePeriodes':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[62] : [];
        break;
      case 'listeCodeActivite':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[77] : [];
        break;
      case 'listetypeContenant':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[13] : [];
        break;
      case 'siteUtilisateur':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[29] : [];
        break;
      case 'listeParking':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[28] : [];
        break;
      case 'listTVA':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[3] : [];
        break;
      case 'listeDepartement':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[72] : [];
        break;
      case 'listeTypeRestrictionZoneGeo':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[85] : [];
        break;
      case 'listeTypeRestrictionArticle':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[86] : [];
        break;
      case 'listeRegion':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[87] : [];
        break;
      case 'listeUniteDEB':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[49] : [];
        break;
      case 'listeNomenclatureICPE':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[74] : [];
        break;
      case 'listFiliere':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[11] : [];
        break;
      case 'listeTypeDoc':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[78] : [];
        break;
      case 'listeOperationsApresProd':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[71] : [];
        break;
      case 'listNatureProduitEnergetique':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[82] : [];
        break;
      case 'listPositionTarifaireHydrocarbure':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[83] : [];
        break;
      case 'listeCodeY':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[79] : [];
        break;
      case 'listeCodeH':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[80] : [];
        break;
      case 'listeEtiquette':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[50] : [];
        break;
      case 'listeDispositionSpeciale':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[53] : [];
        break;
      case 'listePictogramme':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[69] : [];
        break;
      case 'listePictogrammeDanger':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[51] : [];
        break;
      case 'listeMentionAvertissement':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[70] : [];
        break;
      case 'tvaPrincipal':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[65] : [];
        break;
      case 'natureProdHydro':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[84] : [];
        break;
      case 'assoChampFicheClientModule':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[64] : [];
        break;
      case 'assoChampFicheChantierModule':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[89] : [];
        break;
      case 'rapports':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[18] : [];
        break;
      case 'etats':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[10] : [];
        break;
      case 'rapportPerso':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[14] : [];
        break;
      case 'typeActiviteSociete':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[43] : [];
        break;
      case 'typeContrat':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[42] : [];
        break;
      case 'facturationInterim':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[58] : [];
        break;
      case 'typeNonConformite':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[90] : [];
        break;
      case 'typeReleve':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[91] : [];
        break;
      case 'ecoogranisme':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[41] : [];
        break;
      case 'qualificationEquipe':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[44] : [];
        break;
      case 'justificatifDomicile':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[92] : [];
        break;
      case 'listZone':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[6] : [];
        break;
      case 'listTranporteur':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[16] : [];
        break;
      case 'listModeTransport': // mode de transport contrat
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[38] : [];
        break;
      case 'listeMotifSoldageContrat':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[73] : [];
        break;
      case 'typeEquipement':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[54] : [];
        break;
      case 'motifMissionInterim':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[55] : [];
        break;
      case 'motifAccroissement':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[56] : [];
        break;
      case 'motifRefusClient':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[32] : [];
        break;
      case 'listTransporteur':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[16] : [];
        break;
      case 'listFormatAS24':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[46] : [];
        break;
      case 'listDegreUrgence':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[63] : [];
        break;
      case 'typeRaison':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[93] : [];
        break;
      case 'demiJournee':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[94] : [];
        break;
      case 'listTypeArrondiIndice':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[88] : [];
        break;
      case 'tousSite':
        tab = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[0] : [];
        if (tab) {
          for (const i in tab[0]) {
            if (tab[1].length && tab[0].length) {
              liste.push({ id: parseInt(tab[1][i], 10), libelle: tab[0][i], nom: tab[0][i], libelleObjetEntite: tab[0][i] });
            }
          }
          value = liste;
        }
        break;
      case 'typologie':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[95] : [];
        break;
      case 'tableEcoportail':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[96] || {} : {};
        break;
      case 'formaPerso':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[48] : [];
        break;
      case 'typeHabitat':
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[97] : [];
        break;
      case 'listModeTransports': // ecodd
        value = this.local.getObject('globalParam').data ? this.local.getObject('globalParam').data[36] : [];
        break;
    }
    return value;
  }

  getItem(data, id) {
    if (data) {
      const elem = data.filter(elt => parseInt(elt.id, 10) === parseInt(id, 10));
      return elem.length ? elem[0].libelle || elem[0].libelleObjetEntite : '';
    } else {
      return '';
    }
  }

  async getParam() {
    let globalParam = [];
    const param = {
      'servlet': 'DBGetParam',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'SITE': {
          'typeParam': 'int',
          'valeur': this.user[2]
        },
        'USER': {
          'typeParam': 'int',
          'valeur': this.user[0]
        }
      }
    };
    this.isNotFirstLoad = true;
    const datas = await this.post('', { param: param }, this.isLoadingApp ? false : true);
    if (datas) {
      globalParam = datas.data || [];
      this.local.setObject('globalParam', { data: datas.data || [] });
      this.isLoadingApp = false;
    } else {
      this.isLoadingApp = false;
    }
    return globalParam;
  }

  createLog(table, id, etat, suppression?, typeModification?, description?) {
    const nombd = this.local.getObject('nomBDHolding') ?
      this.local.getObject('nomBDHolding').nomBDHolding : '';
    const param = {
      'servlet': 'DBCreateLogModification',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [
        {
          'clefTableEcorec': table,
          'nomclass': 'LogModification',
          'clefEnregistrementTable': id,
          'clefUser': this.user[0],
          'creation': etat,
          'description': description ? description : ''
        },
        this.isProspectHolding ? nombd : '',
        {
          typeParam: 'int',
          valeur: this.local.getObject('societeHolding') && this.local.getObject('societeHolding').id ?
            this.local.getObject('societeHolding').id : 0 // (this.user[2] || 0) // clefSocieteFille mais pas clefSite
        }
      ]
    };
    if (this.isProspectHolding) {
      const socFille = this.local.getObject('societeHolding') || {};
      if (socFille && socFille.id) {
        socFille.nomclass = 'SocieteFille';
        param.data[3] = socFille;
      }
    }

    if (suppression) {
      param.data[0]['suppression'] = true;
    }
    if (typeModification) {
      param.data[0]['typeModification'] = typeModification
    }
    if (id) {
      return this.post('', { param: param }).then(datas => {
        return datas.data;
      });
    } else {
      return Promise.resolve();
    }
  }

  createLogAutreUrl(table, id, etat, url) {
    const param = {
      'servlet': 'DBCreateLogModification',
      'module': 'Recylog',
      'type': 'liste',
      'holding': true,
      'compression': 'false',
      'data': [
        {
          'clefTableEcorec': table,
          'nomclass': 'LogModification',
          'clefEnregistrementTable': id,
          'clefUser': this.user[0],
          'creation': etat,
        },
        '',
        '0'
      ]
    };

    if (id) {
      return this.postHoldingAutre(url, { param: param }).then(datas => {
        return datas.data;
      });
    } else {
      return Promise.resolve();
    }
  }

  async getParamDBGestionDemandeEcoGED(CLEFPARAM) {
    const param = {
      'servlet': 'DBGestionDemandeEcoGED',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 8
        },
        'CLEFPARAM': {
          'typeParam': 'int',
          'valeur': CLEFPARAM
        }
      }
    };

    return await this.post('', { param: param }).then(datas => {
      if (this.verifySession(datas)) {
        return datas;
      }
    });
  }

  checkDroit(data?) {
    const userInfo = this.local.getObject('userInfo');
    if (userInfo) {
      this.getSocieteEcorec().then(soc => {
        const societe = soc;
        const user = this.local.getObject('userDetail');
        if (!user || user && !user.id) {
          this.getUser(this.user[0]).then(() => {
            this.paramDroitAppli(this.userDetail, societe);
          });
        } else {
          if (!this.isLoadingApp && !this.local.getObject('globalParam')) {
            this.getParam();
          }
          this.paramDroitAppli(user, societe);
        }
      });
    }
  }

  paramDroitAppli(user, societe) {
    const isHisto = societe ? (societe.histoPiece ? true : false)
      : false;
    societe = societe || {};
    const DBGetParamConnexion = this.local.getObject('userInfo') || [];
    const rapel = ((user.clefDroit & 0x04000000) !== 0) ? true : false;
    const condition = user.fonctionUser ?
      (user.fonctionUser.id === 1 || user.fonctionUser.id === 4 || user.fonctionUser.id === 5) : false;
    const achat = ((user.clefDroit4 & 0x00001000) !== 0) ? true : false;
    const facture = ((user.clefDroit4 & 0x00000800) !== 0) ? true : false;
    const compta = ((user.clefDroit & 0x00000100) !== 0) ? true : false;
    this.gestionFIP = societe.gestionFIP || false;
    this.isFIPCET = societe.isFIPCET || false;
    this.isEcofact = ((user.clefDroit & 0x20000000) !== 0) ? true : false;
    this.isDroitBonAFacturer = ((user.clefDroit5 & 0x00020000) !== 0) ? true : false;
    this.isGestionFact = ((user.clefDroit & 0x00000200) !== 0) ? true : false;
    this.isEcoloc = ((user.clefDroit2 & 0x00000001) !== 0) ? true : false;
    this.isEcorh = ((user.clefDroit3 & 0x00080000) !== 0) ? true : false;
    this.isDroitGestionPersoEcoRH = ((user.clefDroit4 & 0x02000000) !== 0) ? true : false;
    this.isDroitGestionHeureEcoRH = ((user.clefDroit4 & 0x04000000) !== 0) ? true : false;
    this.isEcobennes = ((user.clefDroit & 0x10000000) !== 0) ? true : false;
    this.isDroitValideRetourEcobennes = ((user.clefDroit & 0x00000008) !== 0) ? true : false;
    this.isPlanningMoyenEcogar = societe.planningMoyen || false;
    this.isDroitCreationMouvementEcobennes = ((user.clefDroit3 & 0x10000000) !== 0) ? true : false;
    this.tarifArticle = ((user.clefDroit3 & 0x00000800) !== 0) ? true : false;
    console.log('this.tarifArticle', this.tarifArticle)
    this.isEcobac = ((user.clefDroit3 & 0x20000000) !== 0) ? true : false;
    this.isFactBon = this.isEcofact;
    this.isFacture = this.isEcofact && facture;
    this.isBonachat = this.isEcofact && achat;
    const comptaFactBAClient =  environment.moduleEcofact && this.isEcofact && compta;
    const comptaremBanque = environment.moduleEcofact && this.isEcofact && compta && societe.isGestionPaiement;
    const comptaBAP = environment.moduleEcopol && ((user.clefDroit4 & 0x00200000) !== 0) ? true : false;
    const comptaCaisse = ((user.clefDroit4 & 0x00400000) !== 0) ? true : false;
    // this.isCompta = this.isEcofact && compta;
    this.isCompta = comptaFactBAClient || comptaremBanque || comptaBAP;
    this.isCaisse = ((user.clefDroit4 & 0x00400000) !== 0) ? true : false;
    this.isFactBonCreat = ((user.clefDroit & 0x00004000) !== 0) ? true : false;
    this.isFactBonImp = ((user.clefDroit3 & 0x00800000) !== 0) ? true : false;
    this.isEcocrm = ((user.clefDroit & 0x04000000) !== 0) ? true : false;
    this.isEcogar = ((user.clefDroit & 0x40000000) !== 0) ? true : false;
    this.isRappel = (this.isEcoloc && (user.personnel && user.personnel.id !== 0)) || (rapel && condition);
    const histo = ((user.clefDroit3 & 0x01000000) !== 0) ? true : false;
    this.isHistoPiece = isHisto && histo;
    this.isHistoBon = ((user.clefDroit4 & 0x80000000) !== 0) ? true : false;
    const conditionRelancePaie = ((user.clefDroit & 0x00000200) !== 0) ? true : false;

    const userclefDroit = ((user.clefDroit & 0x00001000) !== 0) ? true : false;
    const droitecoachat1 = ((user.clefDroit2 & 0x00008000) !== 0) ? true : false;
    const droitecoachat2 = ((user.clefDroit2 & 0x00080000) !== 0) ? true : false;
    const droitecoachat3 = ((user.clefDroit2 & 0x00040000) !== 0) ? true : false;

    this.isModuleEcoachat = userclefDroit && (droitecoachat1 || droitecoachat2 || droitecoachat3) ? true : false;

    this.isRelance = this.isEcofact && conditionRelancePaie && societe.isGestionPaiement;
    this.isPaiement = this.isEcofact && conditionRelancePaie && societe.isGestionPaiement;
    this.isDragDrop = ((user.clefDroit & 0x00000004) !== 0) ? true : false;
    this.isCreateAvoir = ((user.clefDroit3 & 0x00400000) !== 0) ? true : false;
    const droit = ((user.clefDroit3 & 0x00000400) !== 0) ? true : false;
    this.isMajRetroBon = societe.majRetroBon && droit;
    const droit1 = ((user.clefDroit & 0x00004000) !== 0) ? true : false;
    const droit2 = ((user.clefDroit3 & 0x02000000) !== 0) ? true : false;
    this.isEcocontrat = ((user.clefDroit3 & 0x00002000) !== 0) ? true : false;
    this.isContratFact = this.isEcocontrat && (societe.gestionContratHolding === 0 || !societe.gestionContratHolding);
    this.isCreateContrat = ((user.clefDroit3 & 0x00000001) !== 0) ? true : false;
    this.isEditContrat = ((user.clefDroit3 & 0x00000002) !== 0) ? true : false;
    this.isPlanningBac = ((user.clefDroit3 & 0x20000000) !== 0) ? true : false;
    this.isImportCmd = ((user.clefDroit5 & 0x00000001) !== 0) ? true : false;

    this.isEcodec = ((user.clefDroit2 & 0x00000004) !== 0) ? true : false;
    this.isEcodd = ((user.clefDroit & 0x01000000) !== 0) ? true : false;
    this.isEcostockFact = societe.ecostockFact ? true : false;
    this.isDroitGestionEcostock = ((user.clefDroit4 & 0x00000020) !== 0) ? true : false;
    this.isEcostock = ((user.clefDroit4 & 0x00000020) !== 0) ? true : false;

    this.isRDV = ((user.clefDroit5 & 0x00000800) !== 0) ? true : false;

    this.isBtnDupliquer = droit1 && droit2 ? true : false;
    this.isPrestation = societe.SI ? true : false;

    const isExport = ((user.clefDroit4 & 0x04000000) !== 0) && ((user.clefDroit4 & 0x40000000) !== 0) ? true : false;
    const exportInterim = ((user.clefDroit4 & 0x04000000) !== 0) && ((user.clefDroit5 & 0x00000100) !== 0) ? true : false;
    this.isExportPaie = isExport || exportInterim ? true : false;

    this.isDetenteur = societe.clientCollectivite ? true : false;
    this.isTournee = societe.gestionTournees ? true : false;
    this.isGestionDemande = societe.isGestionDemande ? true : false;
    const DROITPARAM = user.clefDroitParam;
    const DROITPARAM2 = user.clefDroitParam2;
    const DROITPARAM3 = user.clefDroitParam3;
    const DROITPARAM4 = user.clefDroitParam4;
    const DROITPARAM5 = user.clefDroitParam5;

    this.isLibradata = societe.urlLibraData && societe.urlLibraData !== '' ? true : false;
    this.isEcodechet = ((user.clefDroit & 0x02000000) !== 0) ? true : false;
    this.isEcopol = ((user.clefDroit & 0x08000000) !== 0) ? true : false;
    this.isProspectHolding = societe.isAppartientHolding && societe.gestionClientHolding && societe.validationClientHolding;

    this.isCreateClient = ((user.clefDroit & 0x00000400) !== 0) ? true : false;
    this.isModifClient = ((user.clefDroit & 0x00000800) !== 0) ? true : false;
    this.isCMchantier = ((user.clefDroit3 & 0x08000000) !== 0) ? true : false;
    const site = this.getType('siteUtilisateur');
    const adresseAutoBAK = site['rechercheAdresse'] && (site['serviceAdresse'] &&
      site['serviceAdresse'].typeServiceAdresse &&
      site['serviceAdresse'].typeServiceAdresse.id === 2) ? true : false;
    if (DROITPARAM4) {
      this.isBAK = ((DROITPARAM4 & 0x00000001) !== 0) ? true : false;
    }
    this.isBAK = this.isBAK || adresseAutoBAK;
    this.isDroitPlanningEcobac = ((user.clefDroit5 & 0x00002000) !== 0) ? true : false;
    this.isDroitValidationEcobac = ((user.clefDroit5 & 0x00004000) !== 0) ? true : false;
    this.isImportFichiersPesees = ((user.clefDroit5 & 0x00008000) !== 0) && societe.clientCollectivite ? true : false;
    this.listFonctionAdmin.forEach(elt => {
      elt.title = elt.libelle;
      if (elt.submenus) {
        elt.submenus.forEach(e => {
          e.title = e.libelleObjetEntite;
          e.visible = ((user[e.code] & e.droit) !== 0) ? true : false;
          e.droitAffiche = ((user[e.code] & e.droit) !== 0) ? true : false;
          //droit ecofact
          if (e.id === 91) {
            e.visible = (e.visible && societe.numFactImpDef) ? true : false;
            e.droitAffiche = (e.droitAffiche && societe.numFactImpDef) ? true : false;
          } else if (e.id === 106) {
            e.visible = (e.visible && societe.numFactImpDef) ? true : false;
            e.droitAffiche = (e.droitAffiche && societe.numFactImpDef) ? true : false;
          } else if (e.id === 108) {
            e.visible = (e.visible && societe.numFactImpDef) ? true : false;
            e.droitAffiche = (e.droitAffiche && societe.numAvoirImpDef) ? true : false;
          } else if (e.id === 125) {
            e.visible = (e.visible && !societe.gestionContratHolding) ? true : false;
            e.droitAffiche = (e.droitAffiche && !societe.gestionContratHolding) ? true : false;
          }

          // Gestion de l'apparition ou non du menu Fonction d'admin > Holding
          if (elt.title === 'Holding') {
            if (this.listeSociete && this.listeSociete.length > 0) {
              /*
              if(societe.gestionClientHolding) {
                if(e.id === 2 && !societe.gestionChantierHolding) { // Supprimer un Chantier en doublon, ne pas l'afficher dans ces conditions
                  e.visible = false;
                  e.droitAffiche = false;                  
                }
              } else { // On n'affiche pas le menu quand on n'est pas sur une societe holding ou societe.isGestionClientHolding=0
                e.visible = false;
                e.droitAffiche = false;                  
              }
              */
            } else {// Quand on n'est pas dans un client holding alors on n'affiche pas le menu holding
              e.visible = false;
              e.droitAffiche = false;
            }
          } else if (this.listeSociete && this.listeSociete.length) {
            // Cacher les menus quand on n'est pas en holding
            // Si on décidera quand même à les afficher, il faut gérer en plus societe.gestionChantierHolding et societe.gestionClientHolding
            // Et sur les appels DBGestionPageAdmin, il faut aussi mettre IS_HOLDING=0 si le menu n'est pas dans le menu Holding                    
            /*
            switch(e.id) {
                case 1 : // Supprimer un Client en doublon
                    if(societe.gestionClientHolding) {
                        e.visible = false;
                        e.droitAffiche = false;                                                                            
                    }
                    break;
                    
                case 2 : // Supprimer un chantier en doublon
                    if(societe.gestionChantierHolding) {
                        e.visible = false;
                        e.droitAffiche = false;                                                                            
                    }
                    break;                
                
                case 4 :  // bloquer/deboquer client
                case 5 :
                case 6 :
                case 9 :
                    if(societe.gestionClientHolding) {
                        e.visible = false;
                        e.droitAffiche = false;                                                                            
                    }
                    break;                                    
                    
                case 165 : // operation supp holding
                    e.visible = false;
                    e.droitAffiche = false;                                                                                            
                    break;
            }
            */
          }

          //droit ecofact
        });
        elt.visible = (elt.submenus.filter(a => a.visible) || []).length ? true : false;
        elt.droitAffiche = true;
      } else {
        elt.visible = true;
        elt.droitAffiche = true;
      }
    });

    this.listFonctionAdminKerlog.forEach(elt => {

      elt.title = elt.libelle;
      if (elt.submenus) {
        elt.submenus.forEach(e => {
          e.title = e.libelleObjetEntite;
          e.visible = (user.adminKerlog) ? true : false;
          e.droitAffiche = (user.adminKerlog) ? true : false;
        });
        elt.visible = true
        elt.droitAffiche = true;
      } else {
        elt.visible = true;
        elt.droitAffiche = true;
      }
    });

    const listFonctionAdmin = this.listFonctionAdmin.filter(e => e.visible);
    const listFonctionAdminkerlog = this.listFonctionAdminKerlog.filter(e => e.visible);

    this.droitParam = {
      cubage: ((DROITPARAM & 0x00004000) !== 0) ? true : false,
      famille: ((DROITPARAM & 0x00010000) !== 0) ? true : false,
      typeCont: ((DROITPARAM & 0x04000000) !== 0) ? true : false,
      indice: ((DROITPARAM & 0x00000400) !== 0) ? true : false,
      activite: ((DROITPARAM & 0x00000001) !== 0) ? true : false,
      civilite: ((DROITPARAM2 & 0x00000800) !== 0) ? true : false,
      champSupp: ((DROITPARAM2 & 0x00080000) !== 0) ? true : false,
      courtier: ((DROITPARAM2 & 0x00004000) !== 0) ? true : false, // ((DROITPARAM & 0x00004000) !== 0) ? true : false,
      bassinAgeEau: ((DROITPARAM & 0x00000004) !== 0) ? true : false,
      broyeurs: ((DROITPARAM & 0x00000008) !== 0) ? true : false,
      emplacementsStock: ((DROITPARAM & 0x00000020) !== 0) ? true : false,
      exutoire: ((DROITPARAM & 0x00000040) !== 0) ? true : false,
      exutoireAgeEau: ((DROITPARAM & 0x00000080) !== 0) ? true : false,
      filliereFacturation: ((DROITPARAM & 0x40000000) !== 0) ? true : false,
      fournisseurs: ((DROITPARAM & 0x00000200) !== 0) ? true : false,
      valeurIndice: ((DROITPARAM2 & 0x00008000) !== 0) ? true : false,
      camions: ((DROITPARAM & 0x00001000) !== 0) ? true : false,
      equipementCamions: ((DROITPARAM & 0x00008000) !== 0) ? true : false,
      familleContrat: ((DROITPARAM2 & 0x08000000) !== 0) ? true : false,
      groupImp: ((DROITPARAM3 & 0x00000200) !== 0) ? true : false,
      contenant: ((DROITPARAM & 0x00000800) !== 0) ? true : false,
      materiel: ((DROITPARAM & 0x00001000) !== 0) ? true : false,
      parking: ((DROITPARAM & 0x08000000) !== 0) ? true : false,
      periode: ((DROITPARAM3 & 0x00000010) !== 0) ? true : false,
      pontBascule: ((DROITPARAM2 & 0x00001000) !== 0) ? true : false,
      qualificationPersonnel: ((DROITPARAM3 & 0x00000001) !== 0) ? true : false,
      sousTypeEquipement: ((DROITPARAM3 & 0x00000020) !== 0) ? true : false,
      sousTypeMateriel: ((DROITPARAM3 & 0x00000100) !== 0) ? true : false,
      transporteur: ((DROITPARAM2 & 0x00000004) !== 0) ? true : false,
      typeEquipement: ((DROITPARAM2 & 0x00000400) !== 0) ? true : false,
      typeEquipementMateriel: ((DROITPARAM & 0x01000000) !== 0) ? true : false,
      typeMateriel: ((DROITPARAM & 0x02000000) !== 0) ? true : false,
      motifRefusDevis: ((DROITPARAM3 & 0x00000008) !== 0) ? true : false,
      typeInstallation5Flux: ((DROITPARAM3 & 0x80000000) !== 0) ? true : false,
      activiteSociete: ((DROITPARAM2 & 0x00010000) !== 0) ? true : false,
      compteSociete: ((DROITPARAM & 0x00000010) !== 0) ? true : false,
      tva: ((DROITPARAM2 & 0x00000008) !== 0) ? true : false,
      utilisateur: ((user.clefDroit & 0x00000002) !== 0) ? true : false,
      profilUtilisateur: ((DROITPARAM2 & 0x01000000) !== 0) ? true : false,
      personnel: ((DROITPARAM & 0x00002000) !== 0) ? true : false,
      parametrage: ((user.clefDroit & 0x00000001) > 0) ? true : false,
      article: ((DROITPARAM & 0x00000002) !== 0) ? true : false,
      familleArticle: ((DROITPARAM & 0x00000100) !== 0) ? true : false,
      sousFamilleArticle: ((DROITPARAM2 & 0x00000002) !== 0) ? true : false,
      axeAnalytiqueArticle: ((DROITPARAM3 & 0x00002000) !== 0) ? true : false,
      agenceInterim: ((DROITPARAM2 & 0x00800000) !== 0) ? true : false,
      operationBac: ((DROITPARAM3 & 0x00004000) !== 0) ? true : false,
      services: ((DROITPARAM2 & 0x00200000) !== 0) ? true : false,
      sites: ((DROITPARAM2 & 0x00000200) !== 0) ? true : false,
      societe: ((DROITPARAM2 & 0x00000001) !== 0) ? true : false,
      motifIndispo: ((DROITPARAM2 & 0x40000000) !== 0) ? true : false,
      typeDocument: ((DROITPARAM3 & 0x00100000) !== 0) ? true : false,
      dechetterie: ((DROITPARAM3 & 0x00040000) !== 0) ? true : false,
      typedepaiement: ((DROITPARAM4 & 0x00000002) !== 0) ? true : false,
      compteEcoportail: ((DROITPARAM4 & 0x00800000) !== 0) ? true : false,
      paiementEnLigne: ((DROITPARAM4 & 0x02000000) !== 0) ? true : false,
      activiteDetenteur: ((DROITPARAM3 & 0x20000000) !== 0) ? true : false,
      fournisseur: ((DROITPARAM & 0x00000200) !== 0) ? true : false,
      holding: societe.isAppartientHolding && DBGetParamConnexion[11] === '1' ? true : false,
      actionRDV: ((DROITPARAM3 & 0x00010000) !== 0) ? true : false,
      typeRDV: ((DROITPARAM3 & 0x00008000) !== 0) ? true : false,
      objectifRDV: ((DROITPARAM3 & 0x00020000) !== 0) ? true : false,
      broyeur: ((DROITPARAM & 0x00000008) !== 0) ? true : false,
      centreVHU: ((DROITPARAM2 & 0x00400000) !== 0) ? true : false,
      rayonStock: ((DROITPARAM & 0x10000000) !== 0) ? true : false,
      badgesPontBascule: ((user.clefDroit2 & 0x00000080) !== 0) ? true : false,
      groupeClient: ((DROITPARAM2 & 0x00020000) !== 0) ? true : false,
      mecanicien: ((DROITPARAM & 0x00100000) !== 0) ? true : false,
      ressource: ((DROITPARAM & 0x20000000) !== 0) ? true : false,
      articlesEntretien: ((DROITPARAM & 0x00200000) !== 0) ? true : false,
      equipementMateriel: ((DROITPARAM & 0x00008000) !== 0) ? true : false,
      typeReparation: ((DROITPARAM2 & 0x20000000) !== 0) ? true : false,
      programmeEntretien: ((DROITPARAM & 0x00400000) !== 0) ? true : false,
      typePropriete: ((DROITPARAM3 & 0x00000040) !== 0) ? true : false,
      gestionNumeroCheque: ((DROITPARAM3 & 0x00000002) !== 0) ? true : false,
      zoneCommune: ((DROITPARAM3 & 0x00080000) !== 0) ? true : false,
      zoneBac: ((DROITPARAM3 & 0x04000000) !== 0) ? true : false,
      augPrixList: ((DROITPARAM2 & 0x00000020) !== 0) ? true : false,
      augPrixNeg: ((DROITPARAM2 & 0x00000040) !== 0) ? true : false,
      augPrixContrat: ((DROITPARAM3 & 0x00000080) !== 0) ? true : false,
      renouveCAP: !societe.isFIPCET && ((DROITPARAM2 & 0x00000080) !== 0) ? true : false,
      impCAP: !this.isDesactiverFormatStandardCAP(30) && ((DROITPARAM2 & 0x00000100) !== 0) ? true : false,
      extraireCAP: true,
      impPersoCAP: ((DROITPARAM2 & 0x00000100) !== 0) ? true : false,
      camera: ((DROITPARAM2 & 0x00001000) !== 0) ? true : false,
      ecoged: ((DROITPARAM3 & 0x08000000) !== 0) ? true : false,
      motifMissionIntermaire: ((DROITPARAM2 & 0x80000000) !== 0) ? true : false,
      formatCompta: ((DROITPARAM2 & 0x04000000) !== 0) ? true : false,
      formatPerso: ((DROITPARAM2 & 0x00100000) !== 0) ? true : false,
      tourVehicule: ((DROITPARAM4 & 0x00000004) !== 0) ? true : false,
      lieuxDepart: ((DROITPARAM2 & 0x02000000) !== 0) ? true : false,
      camionTransporteur: ((DROITPARAM2 & 0x00002000) !== 0) ? true : false,
      cycleTravail: (((DROITPARAM3 & 0x10000000) !== 0) && societe.cycleTravail) ? true : false,
      sectionDevis: (((DROITPARAM3 & 0x00000004) !== 0)) ? true : false,
      frequenceImp: (((DROITPARAM4 & 0x00000008) !== 0)) ? true : false,
      filiereFacturation: (((DROITPARAM & 0x40000000) !== 0)) ? true : false,
      modulation: (((DROITPARAM3 & 0x00000800) !== 0)) ? true : false,
      zoneStockage: (((DROITPARAM4 & 0x00100000) !== 0)) ? true : false,
      fonctionAdmin: (societe.isFonctionAdmin || user.adminKerlog) && listFonctionAdmin && listFonctionAdmin.length ? true : false,
      fonctionAdminkerlog: listFonctionAdminkerlog && listFonctionAdminkerlog.length && user.adminKerlog ? true : false,
      populationCommune: (((DROITPARAM4 & 0x00200000) !== 0)) ? true : false,
      widgetEcoportail: ((DROITPARAM4 & 0x00400000) !== 0) ? true : false,
      motifRefusEcoloc: ((DROITPARAM4 & 0x01000000) !== 0) ? true : false,
      operationContenant: ((DROITPARAM4 & 0x04000000) !== 0) ? true : false,
      commune: ((DROITPARAM4 & 0x08000000) !== 0) ? true : false,
      qualificationDmd: ((DROITPARAM4 & 0x10000000) !== 0) ? true : false,
      questionnaireComposteur: (((DROITPARAM4 & 0x20000000) !== 0) && societe.clientCollectivite) ? true : false,
      informatiqueEmbarque: ((DROITPARAM4 & 0x40000000) !== 0) ? true : false,
      compteTrackDechets: ((DROITPARAM4 & 0x80000000) !== 0) ? true : false,
      motif_refus_fip: ((DROITPARAM3 & 0x00200000) !== 0) ? true : false,
      renouvellementCapDnd: !societe.isFIPCET && ((DROITPARAM5 & 0x00000001) !== 0) ? true : false,
    };
    console.log('this.droitParam', this.droitParam)
    this.droitParamHolding = {
      accesToArticle: ((DROITPARAM4 & 0x00000010) !== 0) ? true : false,
      accesToCamion: ((DROITPARAM4 & 0x00000020) !== 0) ? true : false,
      accesToCourtier: ((DROITPARAM4 & 0x00000040) !== 0) ? true : false,
      accesToCubageContenant: ((DROITPARAM4 & 0x00000080) !== 0) ? true : false,
      accesToExutoire: ((DROITPARAM4 & 0x00000100) !== 0) ? true : false,
      accesToFamilleArticle: ((DROITPARAM4 & 0x00000200) !== 0) ? true : false,
      accesToFamilleContenant: ((DROITPARAM4 & 0x00000400) !== 0) ? true : false,
      accesToIndice: ((DROITPARAM4 & 0x00000800) !== 0) ? true : false,
      accesToSousFamilleArticle: ((DROITPARAM4 & 0x00001000) !== 0) ? true : false,
      accesToTransporteur: ((DROITPARAM4 & 0x00002000) !== 0) ? true : false,
      accesToTypeContenant: ((DROITPARAM4 & 0x00004000) !== 0) ? true : false,
      accesToTypeEquipement: ((DROITPARAM4 & 0x00008000) !== 0) ? true : false,
      accesToUtilisateur: ((DROITPARAM4 & 0x00010000) !== 0) ? true : false,
      accesToClient: ((DROITPARAM4 & 0x00020000) !== 0) ? true : false,
      accesToMateriel: ((DROITPARAM4 & 0x00040000) !== 0) ? true : false,
      accesToPontBascule: ((DROITPARAM4 & 0x00080000) !== 0) ? true : false,
    }
    const indice = ((user.clefDroitParam2 & 0x00008000) !== 0) ? true : false;
    this.isEcoPAV = societe.isEcoPAV ? true : false;
    this.isEcotri = ((user.clefDroit3 & 0x00004000) !== 0) ? true : false;
    const tri = ((user.clefDroit4 & 0x00800000) !== 0) ? true : false;
    const trisortie = ((user.clefDroit4 & 0x01000000) !== 0) ? true : false;
    this.isTri = societe.ecotriEntree && tri ? true : false;
    this.isTriSortie = societe.ecotriSortie && trisortie ? true : false;
    this.isDeleteTournee = ((user.clefDroit4 & 0x00000100) !== 0) ? true : false;
    this.isCarteChauffeurs = ((user.clefDroit5 & 0x00040000) !== 0) ? true : false;
    this.sauvegarderValeurs = indice;
    this.isApproEcocontrat = ((user.clefDroit5 & 0x00100000) !== 0) ? true : false;
    this.isExpedEcocontrat = ((user.clefDroit5 & 0x00200000) !== 0) ? true : false;
    this.isFacturationEcocontrat = ((user.clefDroit5 & 0x00400000) !== 0) ? true : false
  }

  setValueFiltre(filtre) {
    switch (filtre.type) {
      case 1:
        this.filtrePlanning = filtre.filtre;
        break;
      case 2:
        this.filtreValidation = filtre.filtre;
        break;
      case 3:
        this.filtreFact = filtre.filtre;
        break;
      case 4:
        this.filtreBenne = filtre.filtre;
        break;
      case 5:
        this.filtreFacture = filtre.filtre;
        break;
      case 6:
        this.filtreBonachat = filtre.filtre;
        break;
      case 7:
        this.filtreCompta = filtre.filtre;
        break;
      case 8:
        this.filtreDevis = filtre.filtre;
        break;
      case 9:
        this.filtreDevisDupliquerClient = filtre.filtre;
        break;
      case 10:
        this.filtreRelanceFact = filtre.filtre;
        break;
      case 11:
        this.filtrePaiement = filtre.filtre;
        break;
      case 12:
        this.filtreRelancedevis = filtre.filtre;
        break;
      case 13:
        this.filtreContenant = filtre.filtre;
        break;
      case 14:
        this.filtreRetourbon = filtre.filtre;
        break;
      case 15:
        this.filtreRDV = filtre.filtre;
        break;
      case 16:
        this.filtreDetenteur = filtre.filtre;
        break;
      case 17:
        this.filtreProforma = filtre.filtre;
        break;
      case 18:
        this.filtreContrat = filtre.filtre;
        break;
      case 19:
        this.filtrePrestation = filtre.filtre;
        break;
      case 20:
        this.filtrePrestationHisto = filtre.filtre;
        break;
      case 21:
        this.filtreChantier = filtre.filtre;
        break;
      case 22:
        this.filtreTournee = filtre.filtre;
        break;
      case 23:
        this.filtreDemandes = filtre.filtre;
        break;
      case 24:
        this.filtreBAK = filtre.filtre;
        break;
      case 25:
        this.filtreClient = filtre.filtre;
        break;
      case 26:
        this.filtreStockBac = filtre.filtre;
        break;
      case 27:
        this.filtreValidationBac = filtre.filtre;
        break;
      case 28:
        this.filtreEntrees = filtre.filtre;
        break;
      case 29:
        this.filtreSorties = filtre.filtre;
        break;
      case 30:
        this.filtreHistoRetourBon = filtre.filtre;
        break;
      case 31:
        this.filtreBAP = filtre.filtre;
        break;
      case 32:
        this.filtrePlanningRH = filtre.filtre;
        break;
      case 33:
        this.filtreHeures = filtre.filtre;
        break;
      case 34:
        this.filtreAppro = filtre.filtre;
        break;
      case 35:
        this.filtreExpedition = filtre.filtre;
        break;
      case 36:
        this.filtreStockEcostock = filtre.filtre;
        break;
      case 37:
        this.filtreExpeditionEcodd = filtre.filtre;
        break;
      case 38:
        break;
      case 40:
        this.filtreValidationEcogar = filtre.filtre;
        break;
      case 39:
        this.filtrePlanningEcogar = filtre.filtre;
        break;
      case 41:
        this.filtreParcentretienEcogar = filtre.filtre;
        break;
      case 42:
        this.filtreValidationEcogarHistoKm = filtre.filtre;
        break;
      case 43:
        this.filtreEcotri = filtre.filtre;
        break;
      case 44:
        this.filtreEcotriSortie = filtre.filtre;
        break;
      case 45:
        this.filtreEcodecVHU = filtre.filtre;
        break;
      case 46:
        this.filtreBonCommande = filtre.filtre;
        break;
      case 47:
        this.filtreRegistreEntree = filtre.filtre;
        break;
      case 48:
        this.filtreHistoriqueExpe = filtre.filtre;
        break;
      case 49:
        this.filtreRegistreSortie = filtre.filtre;
        break;
      case 50:
        this.filtreHistoBAP = filtre.filtre;
        break;
      case 51:
        this.filtreFIP = filtre.filtre;
        break;
      case 52:
        this.filtreCAP = filtre.filtre;
        break;
      case 53:
        this.filtreUsager = filtre.filtre;
        break;        
    }
  }

  outSide(event, forceclose?, closeDatePicker?) {
    if (event.target.id !== 'autocomplete' || !(event.target.id || '').includes('autocomplete')) {
      if (this.dropdown) {
        this.dropdown.hide();
      }
      this.closeDropdown();
    } else {
      if (!forceclose) {
        if (this.dropdown && this.dropdown['ouvert']) {
          this.dropdown.show();
        }
      }
    }

    const container = $('ngb-datepicker');


    if (closeDatePicker) {
      // if ($(event) && $(event)[0]) {
      const e = event.target;
      console.log(e.className)
      const isInput = e && (e.className && typeof e.className === 'string' &&
        ((e.className || '').includes('input-date') ||
          ((e.className || '').includes('inputTypeDate')))) ? true : false;
      if (!isInput && container && !container.has(e).length) {
        if (this.inputTypeDate && this.inputTypeDate.length > 0) {
          this.inputTypeDate[0].ouvert = false;
        }

        this.inputTypeDate.forEach(elt => elt.close());
      }
      // }
    }
  }

  closeAllAutocomplete() {
    if (this.dropdown) {
      this.dropdown.hide();
      this.closeDropdown()
    } else {
      $('app-autocomplete .dropdown-menu').removeClass('show');
      $('app-autocomplete .dropdown-menu').addClass(' hide');
      this.closeDropdown();
    }
  }


  outSideEcoportail(event) {
    if (event.target.id !== 'ecoportailSearch') {
      this.openRechercheEcoportail = false;
    } else {
      if ($('.ecoportailSearchInput').val() !== '') {
        this.openRechercheEcoportail = true;
      }
    }
  }

  getRappel() {
    const param = {
      'servlet': 'DBGestionReminderDeplacementCommercial',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.user[0]
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.user[2]
        }
      }
    };

    return this.post('', { param: param }).then(datas => {
      if (this.verifySession(datas)) {
        (datas.data || []).forEach(elt => {
          let sujet = '';
          sujet = `${elt.type && elt.type.id ? (elt.type.libelle || elt.type.libelleObjetEntite || '').substring(0, 1).toUpperCase() : ''}`;
          sujet = sujet + ` ${elt.client && elt.client.id && !elt.sujet ? (elt.client.nomClient || '') : (elt.sujet || '')}`;
          sujet = sujet + ` ${!elt.touteLaJournee ? moment(elt.date, 'DD/MM/YYYY HH:mm:ss').format('HH:mm') : ''}`;
          elt.sujet = sujet;
        })
        return datas.data;
      } else {
        return [];
      }
    });
  }

  closeAllModal() {
    if (this.arrayModalRef.length) {
      this.arrayModalRef.forEach(array => {
        array.hide();
      })
      this.arrayModalRef = [];
    }
  }

  /**Evolution modal : by Sarobidy*/
  closeModal() {
    // console.log(this.arrayModalRef)
    if (this.arrayModalRef.length) {
      if (/*this.modalRef || */ this.arrayModalRef.length) {
        // this.modalRef.hide();
        this.arrayModalRef[this.arrayModalRef.length - 1].hide();
        this.arrayModalRef.splice(-1, 1);

      } else {
        $('.modal-backdrop').remove();
        $('.modal').remove();
      }
    } else {
      const event = new KeyboardEvent('keydown', {
        'key': 'Escape'
        // 'keyCode': 27,
        // 'which': 27,
        // 'code': 'Escape',
        // 'location': 0,
        // 'altKey': false,
        // 'ctrlKey': false,
        // 'metaKey': false,
        // 'shiftKey': false,
        // 'repeat': false
      })
      window.dispatchEvent(event);
      this.arrayModalRef = [];
    }


  }

  /**Evolution modal : by Sarobidy*/
  openModal(modalService: BsModalService, template: TemplateRef<any>, config?, notconfirm?, addClass?) {
    if (!config) {
      if (notconfirm) {
        this.config['class'] = notconfirm;
      }
      // this.modalRef = modalService.show(template, this.config);
      this.arrayModalRef.push(modalService.show(template, this.config));
    } else {
      // this.modalRef = modalService.show(template, this.configlg);
      const configlg = Object.assign({}, this.configlg);
      if (addClass) {
        configlg.class = configlg.class + ' ' + addClass
      }
      this.arrayModalRef.push(modalService.show(template, configlg));
    }
    // console.log(this.arrayModalRef)
    setTimeout(() => {
      const children = $('#formIdDmd');
      if (children) {
        // console.log(children)
        children.each(function () {
          const parentniv1 = $(this).parent();
          const parentniv2 = $(parentniv1).parent();
          const parentniv3 = $(parentniv2).parent();
          if (parentniv3) {
            parentniv3.css('z-index', '1045');
          }
        });
      }
    }, 100);
  }

  /**Evolution modal : by Sarobidy*/
  closeAcopteModal() {
    console.log('arrayModalAcompteRef', this.arrayModalAcompteRef)
    if (this.arrayModalAcompteRef.length) {
      if (/*this.modalRef || */ this.arrayModalAcompteRef.length) {
        // this.modalRef.hide();
        this.arrayModalAcompteRef[this.arrayModalAcompteRef.length - 1].hide();
        this.arrayModalAcompteRef.splice(-1, 1);

      } else {
        $('.modal-backdrop').remove();
        $('.modal').remove();
      }
    } else {
      const event = new KeyboardEvent('keydown', {
        'key': 'Escape'
        // 'keyCode': 27,
        // 'which': 27,
        // 'code': 'Escape',
        // 'location': 0,
        // 'altKey': false,
        // 'ctrlKey': false,
        // 'metaKey': false,
        // 'shiftKey': false,
        // 'repeat': false
      })
      window.dispatchEvent(event);
      this.arrayModalAcompteRef = [];
    }
  }

  /**Evolution modal : by Sarobidy*/
  openAcompteModal(modalService: BsModalService, template: TemplateRef<any>, config?) {
    if (!config) {
      // this.modalRef = modalService.show(template, this.config);
      this.arrayModalAcompteRef.push(modalService.show(template, this.config));
    } else {
      // this.modalRef = modalService.show(template, this.configlg);
      this.arrayModalAcompteRef.push(modalService.show(template, this.configlg));
    }
    console.log('openAcompteModal', this.arrayModalAcompteRef)
  }

  openModalDmdEcoGED(modalService: BsModalService, template: TemplateRef<any>, isBadge?) {

    if (isBadge) {
      this.configlgDmd['class'] = 'modal-lg modalperso badgeDetenteur dmdEcoGED'
    }

    this.arrayModalRef.push(modalService.show(template, this.configlgDmd));
  }

  openModalPaiement(modalService: BsModalService, template: TemplateRef<any>) {
    this.arrayModalRef.push(modalService.show(template, this.configPaiement));
  }

  closeModalOpened() {
    this.arrayModalRef.forEach(element => {
      this.closeModal();
    });
  }

  getLogs(id, table, modalService: BsModalService, isHolding?, titre?: any) {
    this.msgError = false;
    this.titreLog = titre || '';
    const param = {
      'servlet': 'DBGestionLogModification',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_RECORD_TABLE': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CLEF_TABLE_ECOREC': {
          'typeParam': 'int',
          'valeur': table
        }
      }
    };
    if (!isHolding) {
      return this.post('', { param: param }).then(datas => {
        this.listLog = datas.data;
        this.getLogModifEtendu(id, table);
        this.openModal(modalService, this.popTemplate);
      });
    } else {
      const paramHolding = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'SOUS_OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_ENREGISTREMENT_TABLE': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CLEF_TABLE_ECOREC': {
          'typeParam': 'int',
          'valeur': table
        }
      };

      this.DBGestionParamHoldingAngular(paramHolding).then(datas => {
        this.listLog = datas.data;
        this.openModal(modalService, this.popTemplate);
      });
    }

  }

  getLastLogs(id, table, isHolding?) {
    const param = {
      'servlet': 'DBGestionLogModification',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_RECORD_TABLE': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CLEF_TABLE_ECOREC': {
          'typeParam': 'int',
          'valeur': table
        }
      }
    };
    if (!isHolding) {
      return this.post('', { param: param }).then(datas => {
        this.lastLog = datas.data;
      });
    } else {
      const paramHolding = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'SOUS_OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_ENREGISTREMENT_TABLE': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CLEF_TABLE_ECOREC': {
          'typeParam': 'int',
          'valeur': table
        }
      };

      return this.DBGestionParamHoldingAngular(paramHolding).then(datas => {
        this.lastLog = datas.data;
      });
    }
  }

  getLogModifEtendu(id, table) {
    const param = {
      'servlet': 'DBGestionLogModification',
      'module': 'Recylog',
      'type': 'map',
      'forcerSerialisation': 'true',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_RECORD_TABLE': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CLEF_TABLE_ECOREC': {
          'typeParam': 'int',
          'valeur': table
        }
      }
    };
    return this.post('', { param: param }).then(datas => {
      this.logModifEtendu = datas.data;
    });
  }

  getLogChrorus(numFacture, modalService: BsModalService) {
    this.msgError = false;
    const param = {
      'servlet': 'DBGestionLogModification',
      'module': 'Recylog',
      'type': 'map',
      'forcerSerialisation': 'true',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'NUM_FACTURE': numFacture
      }
    };
    return this.post('', { param: param }).then(datas => {
      this.logChorus = datas.data;
      this.numFactureChorus = numFacture;
      this.openModalDmdEcoGED(modalService, this.popTemplateChorus);
    });
  }

  getDocument(id, modalService, clefTypeDocPieceEcorec?, afficherBtnDownloadAll?) {
    this.idPiece = id;
    this.typeDoc = '';
    this.afficherBtnDownloadAll = afficherBtnDownloadAll;

    if (!clefTypeDocPieceEcorec) {
      this.clefTypeDocPieceEcorec = 1;
    } else {
      this.clefTypeDocPieceEcorec = clefTypeDocPieceEcorec;
    }

    const param = {
      'servlet': 'DBGestionDocPieceEcorec',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_PIECE_ECOREC': {
          'typeParam': 'int',
          'valeur': id
        },
        'CLEF_TYPE_DOC_PIECE_ECOREC': {
          'typeParam': 'int',
          'valeur': this.clefTypeDocPieceEcorec
        }
      }
    };

    this.post('', { param: param }).then(datas => {
      this.listDoc = datas.data;
      this.openModal(modalService, this.docTemplate, true);
    });
  }
  getDocumentBon(id, modalService, isHisto?, template?, afficherBtnDownloadAll?, showTypeFile?) {
    this.isHisto = isHisto ? true : false;
    this.idPiece = id;
    this.typeDoc = 'bon';
    this.showTypeFile = showTypeFile || false
    this.afficherBtnDownloadAll = afficherBtnDownloadAll;

    const param = {
      'servlet': 'DBGestionDocBon',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 6
        },
        'CLEF_BON': {
          'typeParam': 'int',
          'valeur': id
        },
      }
    };

    this.post('', { param: param }, true).then(datas => {
      this.listDoc = datas.data;
      this.openModal(modalService, template ? template : this.docTemplate, true);
    });
  }

  // getDocumentBon(id, modalService, isHisto, template?) {
  //   this.isHisto = isHisto ? true : false;
  //   this.idPiece = id;
  //   this.typeDoc = 'bon';
  //   const param = {
  //     'servlet': 'DBGestionDocBon',
  //     'module': 'Recylog',
  //     'type': 'map',
  //     'compression': 'false',
  //     'data': {
  //       'OPERATION': {
  //         'typeParam': 'int',
  //         'valeur': 6
  //       },
  //       'CLEF_BON': {
  //         'typeParam': 'int',
  //         'valeur': id
  //       },
  //     }
  //   };

  //   this.post('', { param: param }, true).then(datas => {
  //     this.listDoc = datas.data;
  //     this.openModal(modalService, template ? template : this.docTemplate, true);
  //   });
  // }

  getDiffDate(date1, date2, hours?, startOfDay?) {
    if (!hours) {
      let start = moment(date1, 'DD/MM/YYYY HH:mm:ss');
      let end = moment(date2, 'DD/MM/YYYY HH:mm:ss');
      if (startOfDay) {
        start = start.startOf('day');
        end = end.startOf('day');
      }
      return end.diff(start, 'days');
    } else {
      const start = moment(date1, 'HH:mm:ss');
      const end = moment(date2, 'HH:mm:ss');
      return (end.diff(start, 'hours', true));
    }
  }

  compare_dates(date1, date2) {
    if (date1 < date2) {
      return true;
    } else {
      return false;
    }
  }

  convertToHHMM(info) {
    return Math.round(((info)) * 60);
  }

  sortByID(arr) {
    arr.sort(function (a, b) {
      return Number(a.id) - Number(b.id);
    });
    return arr;
  }

  sortByText(arr, text) {
    arr.sort(function (a, b) {
      if (a[text] < b[text]) {
        return -1;
      }
      if (a[text] > b[text]) {
        return 1;
      }
      return 0;
    });
    return arr;
  }

  toFixed(val, digit?) {
    if (!digit) {
      const nbdigit = this.local.getObject('paramSociete') ? this.local.getObject('paramSociete').nbDigitDevise : 2;
      return parseFloat(val).toFixed(nbdigit);
    } else {
      return parseFloat(val).toFixed(digit);
    }
  }

  toFixedInPopHover(val, digit?) {
    if (!val) return '';
    const nbdigit = digit !== undefined ? digit : (this.local.getObject('paramSociete') ? this.local.getObject('paramSociete').nbDigitDevise : 2);
    return new Intl.NumberFormat('fr-FR', { minimumFractionDigits: nbdigit, maximumFractionDigits: nbdigit }).format(parseFloat(val));
  }


  isDesactiverFormatStandard(clefFormatParametrable) {
    this.getType('listMotifCreationDevis').forEach(tfp => {
      if (tfp.id === clefFormatParametrable && tfp.desactiverFormatStandard) {
        return true;
      }
      if (tfp.id === clefFormatParametrable && tfp.desactiverFormatStandard) {
        return true;
      }
    });
    return false;
  }

  isDesactiverFormatStandardCAP(clefFormatParametrable) {
    this.getType('listeTypesFormatParametrable').forEach(tfp => {
      if (tfp.id === clefFormatParametrable && tfp.desactiverFormatStandard) {
        return true;
      }
    });
    return false;
  }

  safeAssign(source, target) {
    if (source && target) {
      source = target;
    }
  }

  isObjetEntiteEnListe(id, liste) {
    if (id === null || liste === null) {
      return false;
    }
    let r = false;
    liste.forEach(obj => {
      if (obj && (id === obj.id)) {
        r = true;
      }
    });

    return r;
  }

  isObjetEnregistre(obj) {
    return obj && obj.id > 0;
  }

  outsideCalendar(event) {
    const container = $('ngb-datepicker');
    if (event && event.target && event.target.className && typeof event.target.className !== 'object' && (event.target.className.includes('input-date') || event.target.className === 'custom-select' ||
      container.has(event.target).length)) {
      /*this.inputTypeDate.forEach(elt => {
                if (elt.select) {
                    elt.open();
                } else {
                    elt.close();
                }
            });*/
      // $('ngb-datepicker').addClass('show');
    } else {
      /*$('ngb-datepicker').removeClass('show');
            $('ngb-datepicker').hide();*/
      this.inputTypeDate.forEach(elt => {
        elt.close();
      });
      this.inputTypeDate = [];
    }
  }

  calculNotification() {
    let news = 0;
    let fil = 0;
    let doc = 0;
    const lastActu = [];
    this.listActualite.forEach(elt => {
      const date = moment(elt.pubDate, 'DD/MM/YYYY').format('DD/MM/YYYY HH:mm:ss');
      const today = moment().format('DD/MM/YYYY HH:mm:ss');
      const diffDate = this.getDiffDate(date, today);
      if (Math.abs(diffDate) <= 30) {
        news = news + 1;
        lastActu.push(elt);
      }
    });


    this.listFilDicsussion.forEach(elt => fil = fil + elt.nbMessageNonLu);
    this.listRepertoire.forEach(elt => doc = doc + elt.nbDocument);
    this.objetNotify['nbrNews'] = news;
    this.objetNotify['nbrMessage'] = fil;
    const devis = this.listRepertoire.filter(elt => elt.title === 'Devis');
    const bsdd = this.listRepertoire.filter(elt => elt.title === 'BSDD');
    this.objetNotify['nbrDevis'] = devis && devis.length ? devis[0].nbDocument : 0;
    this.objetNotify['nbrBsdd'] = bsdd && bsdd.length ? bsdd[0].nbDocument : 0;
    this.objetNotify['totals'] = news + fil + doc;
    this.objetNotify['lastActu'] = lastActu.length ? lastActu[0] : false;
    this.objetNotify['lastActu'] = this.objetNotify['lastActu'] || (this.listActualite.length ? this.listActualite[0] : false);
    this.objetNotify['nbrDemandeEnlevement'] = 0;

    return this.objetNotify;
  }

  convertHex(hex, opacity) {
    hex = hex || '';
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  }

  changeColor() {
    const user = this.local.getObject('clientLogin') || {};
    const sheet = document.createElement('style');
    const stylePageEcoportail = this.local.getObject('stylePageEcoportail') || {};
    const color = stylePageEcoportail.couleur || '#376194';
    this.reloadHeaderEcoportail = true;
    this.reloadHeaderEcoportail = false;
    sheet.innerHTML = `.mat-badge-content{
          background: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .sk-fading-circle .sk-circle:before {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .active {
           background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .ngx-datatable .active {
            background-color: transparent !important;
        }
        .ecoportail .nav-item i {
            font-size: 18px;
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .nav-item:hover .nav-link {
            border-bottom: 3px solid ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .nav-item:hover i {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .itemRep i, .ecoportail .itemRep .glyphicon {
          color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .navbar .active  svg #path5315 {
            fill: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .navbar .active:hover svg path,
        .ecoportail .navbar .active:hover svg rect,
        .ecoportail .navbar .active:hover svg polygon   {
            fill: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .emojionearea .active {
            background-color: #fff !important;
        }
        .ecoportail .rechercherTop .regular-checkbox-checked:checked {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar {
            background-color: ${user['couleur'] !== '' ? this.convertHex(user['couleur'], 50) :
        this.convertHex(color, 50)} !important;
        }
        .ecoportail .active .mat-badge-content {
            background: #ffffff !important;
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .e-treeview .e-list-item.e-active > .e-text-content .e-list-text {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .corpActu .e-treeview .e-list-item.e-active > .e-text-content .e-list-text {
            color: rgba(0, 0, 0, 0.87) !important;
        }
        .ecoportail .disabledbutton .choixEcoportail {
            background-color: #c0c0c0 !important;
        }

        .ecoportail .choixEcoportail {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .slide-prestation #slide-right {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .slide-prestation #slide-left .btn-ok {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
            box-shadow: none !important;
        }

        .ecoportail .slide-prestation #slide-left .btn-ok:hover {
            background-color: ${user['couleur'] !== '' ? this.convertHex(user['couleur'], 50) :
        this.convertHex(color, 50)} !important;
            box-shadow: none !important;
        }

        .ecoportail .bg-primary {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .slide-prestation #slide-right .btn-close:hover {
            background-color: ${user['couleur'] !== '' ? this.convertHex(user['couleur'], 50) :
        this.convertHex(color, 50)} !important;
            border: solid 1px rgba(255, 255, 255, 0.41);
        }

        .ecoportail .slide-prestation #slide-right .btn-valider {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .slide-prestation #slide-right .btn-valider:hover {
            background-color: #f1f1f1 !important;
            border: solid 1px rgba(255, 255, 255, 0.41);
        }

        .ecoportail .slide-prestation .add-prestation .form-control {
            border: 1px solid ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .slide-prestation #slide-right .form-control {
            border: 1px solid ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .slide-prestation .dropdown-menu {
            border: 1px solid ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .emptyEcoportail .fleche {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .emptyEcoportail h3 {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .emptyEcoportail span {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .e-active > div > span .tocolor {
            fill: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .e-treeview label {
            margin-bottom: 0px;
            padding-bottom: 0px;
            top: -5px;
            position: relative;
        }

        .ecoportail .e-treeview .e-list-item div.e-icons.interaction {
            position: relative;
            top: -5px;
        }

        .ecoportail .disabledbutton .remove-icon {
          color: #c0c0c0 !important;
        }

        .ecoportail .remove-icon {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
            padding: 3px 0 0 !important;
        }

        .ecoportail ::placeholder {
            color: #000 !important;
        }

        .ecoportail ngb-datepicker-navigation .btn-link {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail ngb-datepicker-month-view .ngb-dp-weekday {
             color: ${user['couleur'] !== '' ? this.convertHex(user['couleur'], 50) :
        this.convertHex(color, 50)} !important;
        }
        .ecoportail input[type=checkbox]:checked {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .mat-radio-button.mat-primary .mat-radio-inner-circle {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .mat-radio-button.mat-primary.mat-radio-checked .mat-radio-outer-circle {
            border-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .mat-radio-button.mat-primary.mat-radio-checked .mat-radio-persistent-ripple,
        .ecoportail .mat-radio-button.mat-primary .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple),
        .ecoportail .mat-radio-button.mat-primary:active .mat-radio-persistent-ripple {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
            opacity: 0.3;
        }

        .ecoportail .input-group {
            border: 1px solid ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .btn-recherche, .ecoportail .btn-confirme {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
            border: 1px solid ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .btn-connexion {
            border-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }
        .ecoportail .nonborder i {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail app-mes-rdv .btn-connexion {
            border-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail app-mes-rdv .dateHeure, .ecoportail app-prise-rdv .dateHeure {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail app-recherche-multiple .selected {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail app-recherche-multiple .dropdown-menu>li>a:focus, .ecoportail app-recherche-multiple .dropdown-menu>li>a:hover {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .rdvModal .btn-recherche {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
            border: 1px solid ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .rdvModal .btn-connexion {
            border-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .paramsociete .nav-tabs .nav-item.show .nav-link, .paramsociete .nav-tabs .nav-link.active {
            border-bottom: 2px solid ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .convEcoportail .btn-header {
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .btn-validerEcoportail {
          background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .modalAccesSupp .btn-close {
          background-color: #e7e7e7 !important;
          color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
          text-transform: uppercase;
          outline: none;
          width: 117px;
          height: 30px !important;
          border-radius: 31px;
          border: solid 1px rgba(255, 255, 255, 0.41);
          font-size: 10px !important;
          font-weight: bold;
          letter-spacing: 2px;
        }

        modalAccesSupp .btn-close:hover {
          background-color: #c6c6c6 !important;
        }

        .questionnaireComposteur .btn-close {
          border:  1px solid ${user['couleur'] !== '' ? user['couleur'] : color} !important;
          margin-left: 5px;
        }

        .modalAccesSupp .btn-valider {
          background-color: ${user['couleur'] !== '' ? (user['couleur'] || color) : color} !important;
          border: none !important;
          color: #fff !important;
        }

        .modalAccesSupp .btn-valider:hover {
          background-color: ${user['couleur'] !== '' ? (user['couleur'] || color) : color} !important;
        }

        .modalAccesSupp .regular-checkbox-checked:checked {
          background-color: ${user['couleur'] !== '' ? (user['couleur'] || color) : color} !important;
        }

        .ecoportail {
            background-color: ${stylePageEcoportail.couleurBackgroundMenu} !important;
        }

        .ecoportail app-header-menu .navbar  {
            background-color: ${stylePageEcoportail.couleurBackgroundMenu} !important;
        }

        .ecoportail app-header-menu .nav-item:hover {
            background-color: ${stylePageEcoportail.couleurBoutonMenu} !important;
        }

        .ecoportail .rechercheInput .form-control {
            background-color: transparent!important;
        }

        .ecoportail .navbar-toggler {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail .selectedArticle {
            border: 2px solid ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail ngb-datepicker .bg-primary,
        .modalAccesSupp ngb-datepicker .bg-primary {
          background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .ecoportail ngb-datepicker .ngb-dp-arrow .btn-link,
        .modalAccesSupp ngb-datepicker .ngb-dp-arrow .btn-link {
          color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .modalAccesSupp  .mat-radio-button.mat-accent .mat-radio-inner-circle {
          background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .modalAccesSupp .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {
            border-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .modalAccesSupp .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element {
          opacity: 0.3 !important;     /*click effect color change*/
          background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
        }

        .arrow-right-teom {
            width: 18px;
            height: 21px;
            margin-right: 25px;
            background-color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
            clip-path: polygon(0 0, 0 100%, 100% 50%);
            display: inline-block;
        }
        
        .text-color-teom {
            color: ${user['couleur'] !== '' ? user['couleur'] : color} !important;
            font-weight: bold;
        }
        `;
    document.body.appendChild(sheet);
  }

  sortByStartDate(array, champ) {
    return array.sort((a, b) => {
      return this.getTime(b[champ]) - this.getTime(a[champ]);
    });
  }

  getTime(date?: Date) {
    return date != null ? new Date(date).getTime() : 0;
  }

  getSociete(login) {
    this.getEcoportail(`${this.reformeNomClient(login)}/society/get/staticinfos/${window.location.host}`).then(data => {
      this.local.setObject('societeEcoportail', data[0].society);
    }).catch(error => {
      if (error.message && error.message.includes('Utilisateur non-autentifié ou la session a expiré')) {
        this.logoutEcoportail();
      } else {
        console.log(error);
      }
    });
  }

  getWidget(id?) {
    return this.getEcoportail(`widget/get/list/${id || 0}`).then(data => {
      const listeWidgetDynamique = data.sort((a, b) => parseFloat(a.position) - parseFloat(b.position));
      this.listeWidgetBlocLien = [];
      this.urlRapport = [];
      listeWidgetDynamique.forEach(w => {
        if (w.type && w.type.id === 5) {
          if (w.visible) {
            this.listeWidgetBlocLien.push(w);
          }
        } else {
          w.urlDetail = w.urlDetail || w.url;
          this.urlRapport.push(w);
        }
      });

      // console.log(this.listeWidgetBlocLien);
      // console.log(this.urlRapport);

      this.reloadWidget();
    }).catch(error => {
      if (error.message && error.message.includes('Utilisateur non-autentifié ou la session a expiré')) {
        this.logoutEcoportail();
      } else {
        console.log(error);
      }
    });
  }

  reloadWidget() {
    const user = this.local.getObject('clientLogin') || {};
    const login = Base64.encode(user.login);
    const pwd = Base64.encode(user.pwd);
    this.urlRapport.forEach(elt => {
      elt.url = ((elt.url || '').replace(/#user#/i, login)).replace(/#pwd#/i, pwd);
      elt.urlDetail = ((elt.urlDetail || '').replace(/#user#/i, login)).replace(/#pwd#/i, pwd);
    });
  }

  async getLogoAndColorEcoportail(id?, notobligatoirCode?) {
    const logoLoginLeft = 'assets/images/kerlog.svg';
    const color = '#376194';
    const logoPetit = 'assets/images/Tampon_Kerlog.svg';
    const imgBack = 'assets/images/color52.jpg';
    const text = 'Bienvenue dans votre Espace client';
    const couleurLogin = '#E2E2E2';
    const couleurBoutonMenu = '#fff';
    const couleurBackgroundMenu = '#fff';
    const couleurBackgroundAccueil = '#e6ecf0';
    const key = 'AIzaSyAxUo7NcwRdVXPfyHtkJSfKlpT3l-RSDUg';
    document.title = 'Portail : ';
    /*this.ecoportailPage['logo'] = logoLoginLeft;*/
    const ip_ecoportail = environment.ip_ecoportail;
    this.ecoportailPage['couleur'] = '#fff';
    const path = !!this.local.get('codeExterneClient') ? 'ecoportail/get/list/' +
      this.local.get('codeExterneClient') : 'ecoportail/get/list';
    return this.getEcoportail(path).then(datas => {
      const data = datas && datas.length ? datas[0] : {};
      data['logo'] = data['logo'] && data['logo'] !== '' ?
        ip_ecoportail + data['logo'] : logoLoginLeft;
      data['logoPetit'] = data['logoPetit'] && data['logoPetit'] !== '' ?
        ip_ecoportail + data['logoPetit'] : logoPetit;
      data['imageBack'] = data['imageBack'] && data['imageBack'] !== '' ?
        ip_ecoportail + data['imageBack'] : imgBack;
      data['couleur'] = data['couleur'] && data['couleur'] !== '' ? data['couleur'] : color;
      data['texteAccueil'] = data['texteAccueil'] && data['texteAccueil'] !== '' ? data['texteAccueil'] : text;

      data['couleurLogin'] = data['couleurLogin'] && data['couleurLogin'] !== '' ? data['couleurLogin'] : couleurLogin;
      data['couleurBoutonMenu'] = data['couleurBoutonMenu'] && data['couleurBoutonMenu'] !== '' ?
        data['couleurBoutonMenu'] : couleurBoutonMenu;
      data['couleurBackgroundMenu'] = data['couleurBackgroundMenu'] && data['couleurBackgroundMenu'] !== '' ?
        data['couleurBackgroundMenu'] : couleurBackgroundMenu;
      data['couleurBackgroundAccueil'] = data['couleurBackgroundAccueil'] &&
        data['couleurBackgroundAccueil'] !== '' ? data['couleurBackgroundAccueil'] : couleurBackgroundAccueil;

      data['fluxEbutuoy'] = data['fluxEbutuoy'] &&
        data['fluxEbutuoy'] !== '' ? data['fluxEbutuoy'] : key;
      this.ecoportailPage = data;
      this.local.setObject('stylePageEcoportail', data);
      if (!notobligatoirCode) {
        this.obligatoireCodeClient(true, true);
      }
      document.title = 'Portail : ' + (data['nomSociete'] || '');
      return datas ? datas[0] : {};
    }).catch(error => {
      this.ecoportailPage['logo'] = logoLoginLeft;
      this.ecoportailPage['couleur'] = color;
      this.ecoportailPage['texteAccueil'] = text;
    });
  }

  getLogoAndColor() {
    return this.get('/get/style/page').then(datas => {
      this.local.setObject('stylePage', datas);
      return datas;
    });
  }

  isDateCorrect(val) {
    if (val && typeof val === 'string') {
      return val.match(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/) ? val : 'Date invalide';
    } else {
      if (typeof val === 'object') {
        return moment(val).format('DD/MM/YYYY');
      } else {
        return false;
      }
    }
  }


  saveNavigation(idPage) {
    this.getEcoportail(`/log/save/${idPage}`).then(datas => {
    }).catch(error => {
    });
  }



  isParamEcoPortailActif(param) {
    let actif = false;
    const user = this.local.getObject('clientLogin') || {};
    if (user && user.listParamEcoPortail) {
      user.listParamEcoPortail.forEach(paramEcoPortail => {
        if (paramEcoPortail.param.toLowerCase() === param.toLowerCase()) {
          actif = paramEcoPortail.actif;
        }
      });
    }
    return actif;
  }


  isParamEcoPortailActifDepuisEcorec(param, listParamEcoPortail) {
    let actif = false;
    if (listParamEcoPortail) {
      listParamEcoPortail.forEach(paramEcoPortail => {
        if (paramEcoPortail.param.toLowerCase() === param.toLowerCase()) {
          actif = paramEcoPortail.actif;
        }
      });
    }

    return actif;
  }

  arrayToObjet(tab) {
    const liste = [];
    for (const i in tab[0]) {
      if (tab[1].length && tab[0].length) {
        liste.push({ id: parseInt(tab[1][i], 10), libelle: tab[0][i], libelleObjetEntite: tab[0][i] });
      }
    }
    return liste;
  }

  visibleChampFicheClient(numChamp, listAssoChampFicheClientModule) {
    this.getModule();
    let activedModule = this.activedModule;
    const url = window.location.href || '';
    if (url.includes('/fiche_client_2')) {
      activedModule = 6;
      // activedModule = 0; // cf skype Eli;
    }

    const paramSociete = this.local.getObject('paramSociete') || {};
    let visible = false;
    const asso = listAssoChampFicheClientModule.filter(elt => elt.champ && elt.module &&
      elt.champ.id === numChamp && elt.module.id === activedModule);
    if (asso.length) {
      visible = asso[0].visible;
    } else {
      visible = (!paramSociete.filtreChampsFicheClient || paramSociete.visibiliteParDefaultNouveauChamps);
    }
    return visible;
  }

  visibleChampFicheChantier(numChamp, listAssoChampFicheChantierModule) {
    this.getModule();
    let activedModule = this.activedModule;
    const url = window.location.href || '';
    if (url.includes('/fiche_client_2')) {
      activedModule = 6;
      // activedModule = 0; // cf skype Eli;
    }

    // const listAssoChampFicheChantierModule = this.getType('assoChampFicheChantierModule') || [];
    const paramSociete = this.local.getObject('paramSociete') || {};
    // console.log('visibleChampFicheChantier', activedModule)
    let visible = false;
    const asso = listAssoChampFicheChantierModule.filter(elt => elt.champ && elt.module &&
      elt.champ.id === numChamp && elt.module.id === activedModule);

    if (asso.length) {
      visible = asso[0].visible;
    } else {
      visible = (!paramSociete.filtreChampsFicheChantier || paramSociete.visibiliteParDefaultNouveauChamps);
    }
    return visible;
  }

  getModule() {
    const url = window.location.href || '';
    this.activedModule = 0;
    if (url.includes('/ecobennes')) {
      this.activedModule = 1;
    }
    if (url.includes('/recylog/prestation')) {
      this.activedModule = 1;
    }
    if (url.includes('/recylog/adv')) {
      this.activedModule = 1;
    }
    if (url.includes('/ecofact')) {
      this.activedModule = 2;
    }
    if (url.includes('/ecodechet')) {
      this.activedModule = 3;
    }
    if (url.includes('/ecopol')) {
      this.activedModule = 4;
    }
    if (url.includes('/ecodd')) {
      this.activedModule = 5;
    }
    if (url.includes('/ecocrm')) {
      this.activedModule = 6;
    }
    if (url.includes('/ecocontrat')) {
      this.activedModule = 6;
    }
    if (url.includes('/ecodec')) {
      if (url.includes('/ecodechet')) {
        this.activedModule = 3;
      } else {
        this.activedModule = 7;
      }
    }
    if (url.includes('/ecodechetterie')) {
      this.activedModule = 8;
    }
    if (url.includes('/ecoloc')) {
      this.activedModule = 9;
    }
    if (url.includes('/ecoachat')) {
      this.activedModule = 10;
    }
    if (url.includes('/ecotri')) {
      this.activedModule = 11;
    }
    if (url.includes('/ecorh')) {
      this.activedModule = 12;
    }
    if (url.includes('/ecodechetterie')) {
      this.activedModule = 13;
    }
    if (url.includes('/ecoaffaires')) {
      this.activedModule = 14;
    }
    if (url.includes('/ecostock')) {
      this.activedModule = 15;
    }
    if (url.includes('/ecobac')) {
      this.activedModule = 16;
    }
    if (url.includes('/ecobac')) {
      this.activedModule = 16;
    }
    if (url.includes('/recylog/fiche_client_2')) {
      // this.activedModule = 6;
      // console.log('>>>> MODULE ECOCRM');
      this.activedModule = 0;
      // cf skype Eli => visibilité Recherche ;
    }
  }

  getID(url) {
    let activedModule = 0;
    if (url.includes('/ecobennes')) {
      activedModule = 1;
    }
    if (url.includes('/recylog/prestation')) {
      activedModule = 1;
    }
    if (url.includes('/recylog/adv')) {
      activedModule = 1;
    }
    if (url.includes('/ecofact')) {
      activedModule = 2;
    }
    if (url.includes('/ecodechet')) {
      activedModule = 3;
    }
    if (url.includes('/ecopol')) {
      activedModule = 4;
    }
    if (url.includes('/ecodd')) {
      activedModule = 5;
    }
    if (url.includes('/ecocrm')) {
      activedModule = 6;
    }
    if (url.includes('/ecocontrat')) {
      activedModule = 18;
    }
    if (url.includes('/ecodec')) {
      if (url.includes('/ecodechet')) {
        activedModule = 3;
      } else {
        activedModule = 7;
      }
    }
    if (url.includes('/ecodechetterie')) {
      activedModule = 8;
    }
    if (url.includes('/ecoloc')) {
      activedModule = 9;
    }
    if (url.includes('/ecoachat')) {
      activedModule = 10;
    }
    if (url.includes('/ecotri')) {
      activedModule = 11;
    }
    if (url.includes('/ecorh')) {
      activedModule = 12;
    }
    if (url.includes('/ecodechetterie')) {
      activedModule = 13;
    }
    if (url.includes('/ecoaffaires')) {
      activedModule = 14;
    }
    if (url.includes('/ecostock')) {
      activedModule = 15;
    }
    if (url.includes('/ecobac')) {
      activedModule = 16;
    }
    if (url.includes('/ecobac')) {
      activedModule = 16;
    }
    if (url.includes('/ecogar')) {
      activedModule = 17;
    }
    if (url.includes('/ecocontrat')) {
      activedModule = 18;
    }
    if (url.includes('/recylog/param')) {
      activedModule = 19;
    }
    if (url.includes('/import')) {
      activedModule = 20;
    }
    if (url.includes('/ecofact/gestion_compta')) {
      activedModule = 21;
    }
    if (url.includes('/recylog/fiche_detenteur')) {
      activedModule = 22;
    }
    if (url.includes('/recylog/bak')) {
      activedModule = 23;
    }
    return activedModule

  }

  DBGestionChampFicheParametrage(type) {
    this.post('', {
      param: {
        'servlet': 'DBGestionChampFicheParametrage',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 2
          },
          'USER': {
            'typeParam': 'int',
            'valeur': this.user[0]
          },
          'TABLE_ECOREC': {
            'typeParam': 'int',
            'valeur': type
          },
        }
      }
    }).then(data => {
      this.paramSociete = data.data;
      if (this.verifySession(data)) {
        if (data.data) {
          this.listAccesChampFicheParam['' + type] = data.data || [];
        }
      }
    }).catch(error => console.log(error));
  }

  getChampClient(id) {
    this.listAccesChampFicheParam['1'] = this.listAccesChampFicheParam['1'] || [];
    const existe = this.listAccesChampFicheParam['1'].filter(elt => elt.champ && elt.champ.id === id);
    if (existe && existe.length) {
      existe[0].visible = true;
      return existe[0];
    } else {
      return {
        creation: true,
        modifiable: true,
        visible: true,
        vision: true
      }
    }
  }

  changeFn(detail, element, e) {
    detail[element] = e.target.value;
  }

  getParamSociete() {
    return this.post('', {
      param: {
        'servlet': 'DBGetSociete',
        'module': 'Recylog',
        'type': 'tableau',
        'compression': 'false',
        'data': []
      }
    }).then(data => {
      this.paramSociete = data.data;
      if (this.verifySession(data)) {
        if (data.data) {
          data.data['nbDigitDevise'] = data.data['nbDigitDevise'] || 0;
          data.data['nbrDigitTarif'] = data.data['nbrDigitTarif'] || 0;
          data.data['nbrDigitQte'] = data.data['nbrDigitQte'] || 0;
          data.data['nbrDigitQteEcopol'] = data.data['nbrDigitQteEcopol'] || 0;
          data.data['nbrDigitIndice'] = data.data['nbrDigitIndice'] || 0;
          this.local.setObject('paramSociete', data.data || {});
          this.checkSessions();
          return data.data || {};
        } else {
          if (data.message) {
            this.local.setObject('paramSociete', {});
            return data.data || {};
          }
        }
      }

    }).catch(error => console.log(error));
  }

  getSocieteEcorec() {
    const societe = this.local.getObject('paramSociete') || {};
    if (societe.id) {
      return Promise.resolve(societe);
    } else {
      if (this.user[0]) {
        return this.getParamSociete();
      } else {
        return Promise.resolve({});
      }

    }
  }

  getUser(id) {
    return this.post('', {
      param: {
        'servlet': 'DBGetUser',
        'module': 'Recylog',
        'type': 'tableau',
        'compression': 'false',
        'data': [
          'DBGetUser',
          id
        ]
      }
    }).then(datas => {
      if (this.verifySession(datas)) {
        if (datas.data) {
          const user = this.local.getObject('userDetail') || {};
          const pwd = user.pwd || '';
          datas.data[0].pwd = user.pwd || '';
          this.local.setObject('userDetail', datas.data[0]);
          this.userDetail = datas.data[0];
          this.checkDroit(datas.data[0]);
          if (!this.local.getObject('globalParam')) {
            this.getParam();
          }
          return this.userDetail;
        }
      }

    }).catch(error => console.error(error));
  }

  parseMessage(msg) {
    const message = ((((msg || '').replace(/<div><\/div>/g, '\n')).replace(/<div>/g, '\n')).replace(/<\/div>/g, ''))
    return (message || '').replace(/<br>/g, '\n');
  }

  clone(o1) {
    return JSON.parse(JSON.stringify(o1));
  }

  getObjetById(data, id) {
    let ret = false;
    if (data) {
      data.forEach(elt => {
        if (parseInt(elt.id, 10) === parseInt(id, 10)) {
          ret = elt;
          return;
        }
      });
    }

    return ret;
  }

  parseValueBooleanClient(detail) {
    detail = detail || {};
    detail.isGarage = detail.isGarage || false;
    detail.isEcoEnvironnement = detail.isEcoEnvironnement || false;
    detail.entrepriseTravaux = detail.entrepriseTravaux || false;
    detail.maitreOuvrage = detail.maitreOuvrage || false;
    detail.isNegociant = detail.isNegociant || false;
    detail.isEcodechetterie = detail.isEcodechetterie || false;

    detail.isCompte = detail.isCompte || false;
    detail.infoChanterSynthetique = detail.infoChanterSynthetique || false;
    detail.factBonImmediat = detail.factBonImmediat || false;
    detail.fraisFacturation = detail.fraisFacturation || false;
    detail.numBonManuelObligatoire = detail.numBonManuelObligatoire || false

    detail.isTVA = detail.isTVA || false;
    detail.factAgence = detail.factAgence || false;
    detail.factParAgence = detail.factParAgence || false;
    detail.isFactChantier = detail.isFactChantier || false;
    detail.isFactParChantier = detail.isFactParChantier || false;
    detail.isFactSynth = detail.isFactSynth || false;
    detail.BASynth = detail.BASynth || false;
    detail.isTEOM = detail.isTEOM || false;

    detail.isGroupe = detail.isGroupe || false;
    detail.societeGroupe = detail.societeGroupe || false;
    detail.paiementFinMois = detail.paiementFinMois || false;
    detail.isForfait = detail.isForfait || false;
    detail.isLoc = detail.isLoc || false;
    detail.isLocJournalier = detail.isLocJournalier || false;
    detail.isLocImmediat = detail.isLocImmediat || false;
    detail.isCapChantier = detail.isCapChantier || false;
    detail.isAgenceEau = detail.isAgenceEau || false;
    detail.isDMS = detail.isDMS || false;
    detail.nonChantierBSDD = detail.nonChantierBSDD || false;
    detail.forfaitDeplacement = detail.forfaitDeplacement || false;
    detail.fraisFacturation = detail.fraisFacturation || false;
    detail.facturationPartielle = detail.facturationPartielle || false;
    detail.imprimeRecapFact = detail.imprimeRecapFact || false;
    detail.imprimeRecapBonAchat = detail.imprimeRecapBonAchat || false;
    detail.impFactTonne = detail.impFactTonne || false;
    detail.impressionFactureAvecTraite = detail.impressionFactureAvecTraite || false;
    detail.isFactAPart = detail.isFactAPart || false;
    detail.isImpCert = detail.isImpCert || false;
    detail.divers = detail.divers || false;
    detail.affacturage = detail.affacturage || false;
    detail.jourFacturationDefini = detail.jourFacturationDefini || false;
    detail.mandatFacturation = detail.mandatFacturation || false;
    detail.limiteExutoires = detail.limiteExutoires || false;
    detail.factureParMail = detail.factureParMail || false;
    detail.numBSDFacture = detail.numBSDFacture || false;
    detail.infoChantierFacture = detail.infoChantierFacture || false;
    detail.isChorus = detail.isChorus || false;
    detail.isTrackDechet = detail.isTrackDechet || false;
    detail.isBonChiffre = detail.isBonChiffre || false;
  }

  convUnite(qte, art, clefUnite, clefUniteConv) {
    clefUnite = parseInt(clefUnite, 10);
    clefUniteConv = parseInt(clefUniteConv, 10);

    console.log('Calling convUnite(' + qte + ', art,' + clefUnite + ', ' + clefUniteConv + ')');

    art['poidsTheo'] = art['poidsTheo'] ? art['poidsTheo'] : 1;
    art['masseVolumique'] = art['masseVolumique'] ? art['masseVolumique'] : 1;

    if (clefUnite == clefUniteConv)
      return qte;

    switch (clefUnite) {
      case ConstanteEcorec.UNITE_KG:
        console.log('ConstanteEcorec.UNITE_KG');
        switch (clefUniteConv) {
          case ConstanteEcorec.UNITE_T:
            console.log('ConstanteEcorec.UNITE_T');
            return qte / 1000.00;
          case ConstanteEcorec.UNITE_U:
          case ConstanteEcorec.UNITE_FUT:
            return qte / art.poidsTheo;
          case ConstanteEcorec.UNITE_MCUBE:
            return qte / art.masseVolumique / 1000.00;
          case ConstanteEcorec.UNITE_L:
            return qte / art.masseVolumique;
        }
        return qte;

      case ConstanteEcorec.UNITE_T:
        switch (clefUniteConv) {
          case ConstanteEcorec.UNITE_KG:
            return qte * 1000.00;
          case ConstanteEcorec.UNITE_U:
          case ConstanteEcorec.UNITE_FUT:
            return qte * 1000.00 / art.poidsTheo;
          case ConstanteEcorec.UNITE_MCUBE:
            return qte / art.masseVolumique;
          case ConstanteEcorec.UNITE_L:
            return qte * 1000.00 / art.masseVolumique;
        }
        return qte;

      case ConstanteEcorec.UNITE_U:
      case ConstanteEcorec.UNITE_FUT:
        switch (clefUniteConv) {
          case ConstanteEcorec.UNITE_KG:
            return qte * art.poidsTheo;
          case ConstanteEcorec.UNITE_T:
            return qte * art.poidsTheo / 1000.00;
          case ConstanteEcorec.UNITE_MCUBE:
            return qte * art.poidsTheo / art.masseVolumique / 1000.00;
          case ConstanteEcorec.UNITE_L:
            return qte * art.poidsTheo / art.masseVolumique;
          case ConstanteEcorec.UNITE_U:
          case ConstanteEcorec.UNITE_FUT:
            return qte;
        }
        return qte;

      case ConstanteEcorec.UNITE_MCUBE:
        switch (clefUniteConv) {
          case ConstanteEcorec.UNITE_KG:
            return qte * art.masseVolumique * 1000.00;
          case ConstanteEcorec.UNITE_T:
            return qte * art.masseVolumique;
          case ConstanteEcorec.UNITE_U:
          case ConstanteEcorec.UNITE_FUT:
            return qte * art.masseVolumique * 1000.00 / art.poidsTheo;
          case ConstanteEcorec.UNITE_L:
            return qte * 1000.00;
        }
        return qte;

      case ConstanteEcorec.UNITE_L:
        switch (clefUniteConv) {
          case ConstanteEcorec.UNITE_KG:
            return qte * art.masseVolumique;
          case ConstanteEcorec.UNITE_T:
            return qte * art.masseVolumique / 1000.00;
          case ConstanteEcorec.UNITE_U:
          case ConstanteEcorec.UNITE_FUT:
            return qte * art.masseVolumique / art.poidsTheo;
          case ConstanteEcorec.UNITE_MCUBE:
            return qte / 1000.00;
        }
        return qte;
    }
    return qte;
  }

  parseFromLib(lib) {
  }

  getInfoEcorec() {
    return this.post('', {
      param: {
        'servlet': 'DBGetInfoAboutEcorec',
        'module': 'Recylog',
        'type': 'tableau',
        'compression': 'false',
        'data': ['DBGetInfoAboutEcorec']
      }
    });
  }

  openModalInfo(modalService) {
    this.getInfoEcorec().then(datas => {
      if (datas.data !== null) {
        this.objetApropos = datas.data || {};
        const COPYRIGHT = `&copy; ${moment().format('YYYY')}. Tous droits réservés.
                EcoREC et les logos EcoREC sont des marques déposées de KERLOG.`;
        this.objetApropos['COPYRIGHT'] = this.objetApropos['COPYRIGHT'] !== '' ? this.objetApropos['COPYRIGHT'] : COPYRIGHT;
        this.openModal(modalService, this.tplApropos);
      }
    });
  }

  getImprimanteSerie(isZebra?, spinner?) {
    console.log('Calling getImprimanteSerie()');
    const param = {
      'servlet': 'DBGestionImprimanteSerie',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'IS_ZEBRA': {
          'typeParam': 'boolean',
          'valeur': isZebra
        },
      }
    };

    return this.post('', { param: param }, spinner || false);
  }

  getCertificat() {
    console.log('Calling getImprimanteSerie()');
    const param = {
      'servlet': 'DBGestionImprimanteSerie',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
      }
    };

    return this.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

  getContenuImpressionZPL(cletSite, bon, ligneBon) {
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 12
        },
        'SITE': '' + cletSite,
        'BON': bon,
        'LIGNE_BON': ligneBon
      }
    };

    return this.post('', { param: param });
  }

  getWarDeployer() {
    this.getListParamEcranEcorec(1);
    this.getListPeriode();
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 30
        },
      }
    };

    return this.post('', { param: param }).then(datas => {
      console.log("war", datas);
      const element = datas.data || [];

      environment.moduleEcobennes = element.includes('Ecobennes') ? true : false;
      environment.moduleEcocontrat = element.includes('Ecocontrat') ? true : false;
      environment.moduleEcofact = element.includes('Ecofact') ? true : false;
      environment.moduleEcoloc = element.includes('Ecoloc') ? true : false;
      environment.moduleEcocrm = element.includes('Ecocrm') ? true : false;
      environment.moduleEcodd = element.includes('Ecodd') ? true : false;
      environment.moduleEcodec = element.includes('Ecodec') ? true : false;
      environment.moduleEcodechet = element.includes('Ecodechet') ? true : false;
      environment.moduleEcopol = element.includes('Ecopol') ? true : false;
      environment.moduleEcogar = element.includes('Ecogar') ? true : false;
      environment.moduleEcotri = element.includes('Ecotri') ? true : false;
      environment.moduleEcorh = element.includes('EcoRH') ? true : false;
      // environment.moduleEcoaffaires = element.includes('Ecoaffaires') ? true : false;
      // environment.moduleEcoachat = element.includes('Ecoachat') ? true : false;
      // environment.moduleEcoPrax = element.includes('EcoPrax') ? true : false;
      environment.moduleEcocarto = element.includes('EcoCarto') ? true : false;
      environment.moduleEcobac = element.includes('Ecobac') ? true : false;
      environment.moduleEcostock = element.includes('Ecostock') ? true : false;
      environment.moduleRDV = element.includes('EcoPortail') ? true : false;

      this.doSomethingAfterGetWarDeployer.next(element)
    });
  }

  getContenuImpressionZebra(contenuFileZebra, cletSite, bon, ligneBon) {
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 13
        },
        'CONTENU_FILE_ZEBRA': contenuFileZebra,
        'SITE': '' + cletSite,
        'BON': bon,
        'LIGNE_BON': ligneBon
      }
    };

    return this.post('', { param: param });
  }

  DBGestionParamHoldingAngular(parametre, isSpinner?, isExportXls?) {
    const user = this.local.getObject('userDetail') || {};
    const societeHolding = this.local.getObject('societeHolding') || {};
    const paramData = {
      'USER': {
        'typeParam': 'int',
        'valeur': user.id || 0
      },
      'LOGIN': user.login || '',
      'CLEF_SOCIETE_FILLE': {
        'typeParam': 'int',
        'valeur': societeHolding.id || 0
      },
    }

    if (isExportXls) {
      paramData['CLEF_SITE'] = {
        'typeParam': 'int',
        'valeur': this.user[2] || 0
      }
    }

    const allParam = { ...paramData, ...(parametre || {}) }
    const param = {
      'servlet': 'DBGestionParamHoldingAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': allParam
    };

    if (isExportXls) {
      param['pathImpression'] = 'Recylog/tmp'
    }
    const isHolding = this.local.get('isHolding');
    if (isHolding) {
      return this.post('', { param: param }, isSpinner || false);
    } else {
      return Promise.resolve();
    }

  }

  DBGestionAppelHolding(parametre, operation?) {
    const user = this.local.getObject('userDetail') || {};
    const societeHolding = this.local.getObject('societeHolding') || {};
    const paramData = {
      'HOLDING_OPERATION': {
        'typeParam': 'int',
        'valeur': operation ? operation : 1
      },
      'HOLDING_USER_STE_FILLE': {
        'typeParam': 'int',
        'valeur': user.id || 0
      },
      'HOLDING_SITE_STE_FILLE': {
        'typeParam': 'int',
        'valeur': this.user[2] || 0
      },
      'HOLDING_USER_LOGIN': user.login || '',
      'HOLDING_CLEF_STE_FILLE': {
        'typeParam': 'int',
        'valeur': societeHolding.id || 0
      },
    }

    const allParam = { ...paramData, ...(parametre || {}) }
    const param = {
      'servlet': 'DBGestionAppelHolding',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': allParam
    };

    // return this.post('', { param: param });
    const isHolding = this.local.get('isHolding');
    if (isHolding) {
      return this.post('', { param: param });
    } else {
      return Promise.resolve();
    }
  }

  getContenuEtiquetteZebraInterventionBAC(contenuFileZebra, listeClefInterv, operation?, IS_IMPRIMER_TOUT_CONTENANT?, spinner?) {
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': operation ? operation : 14
        },
        'CONTENU_FILE_ZEBRA': contenuFileZebra,
        'LIST_ID_INTERVENTION': listeClefInterv,
        'IS_IMPRIMER_TOUT_CONTENANT': {
          'typeParam': 'boolean',
          'valeur': IS_IMPRIMER_TOUT_CONTENANT || false
        },
      }
    };

    return this.post('', { param: param }, spinner || false);
  }

  isDroitEcoGED(paramRigthEcoGED, paramUserEcoGED) {
    let actifRigthEcoged = false, actifUserEcoged = false;
    const customerEcoPortail = this.local.getObject('customerEcoPortail') || {};
    if (customerEcoPortail && customerEcoPortail.rightsEcoGED) {
      actifRigthEcoged = customerEcoPortail.rightsEcoGED[paramRigthEcoGED];

    }
    if (customerEcoPortail && customerEcoPortail.userEcoGED) {
      actifUserEcoged = customerEcoPortail.userEcoGED[paramUserEcoGED];

    }
    return actifRigthEcoged && actifUserEcoged;
  }

  changeDateFormat(event, objetPrincipal) {
    clearTimeout(this.delay);
    const date = objetPrincipal[event];

    console.log(date)
    const ctrl = this;
    const DDMMYYYY = date.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-\.](0?[1-9]|1[012])[\/\-\.]\d{4}$/) ? true : false;
    this.delay = setTimeout(function () {
      if (DDMMYYYY) {
        objetPrincipal[event] = moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY');
      } else {
        if (date && date.length === 6) {
          if (!date.includes('/') && moment(date, 'DDMMYY').isValid()) {
            objetPrincipal[event] = moment(date, 'DDMMYY').format('DD/MM/YYYY');
            // console.log(objetPrincipal[event], moment(date, 'DDMMYY').format('DD/MM/YYYY'));
          }
        } else if (date && date.length === 8) {
          if (!date.includes('/') && moment(date, 'DDMMYYYY').isValid()) {
            objetPrincipal[event] = moment(date, 'DDMMYYYY').format('DD/MM/YYYY');
            // console.log(objetPrincipal[event], moment(date, 'DDMMYYYY').format('DD/MM/YYYY'))
          } else if (moment(date, 'DD/MM/YY').isValid()) {
            objetPrincipal[event] = moment(date, 'DD/MM/YY').format('DD/MM/YYYY');
            // console.log(objetPrincipal[event], moment(date, 'DDMMYYYY').format('DD/MM/YYYY'))
          }
        } else if (date && date.length === 10) {
          if (moment(date, 'DD/MM/YYYY').isValid()) {
            objetPrincipal[event] = moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY');
          }
        } else {
          if (date && date.length > 10) {
            objetPrincipal[event] = '';
          }
        }
      }
    }, 1000);
  }

  keyupNumber(event) {
    // Prevent shift key since its not needed
    if (event.shiftKey === true) {
      event.preventDefault();
    }
    // Allow Only: keyboard 0-9, numpad 0-9, backspace, tab, left arrow, right arrow, delete
    if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) ||
      event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 46) {
      // Allow normal operation
    } else {
      // Prevent the rest
      event.preventDefault();
    }
  }

  getMIMETypeByFileName(filename) {
    const extension = filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
    const listMIME = {
      'aac': 'audio/aac',
      'abw': 'application/x-abiword',
      'ai': 'application/postscript',
      'arc': 'application/octet-stream',
      'avi': 'video/x-msvideo',
      'azw': 'application/vnd.amazon.ebook',
      'bin': 'application/octet-stream',
      'bz': 'application/x-bzip',
      'bz2': 'application/x-bzip2',
      'csh': 'application/x-csh',
      'css': 'text/css',
      'csv': 'text/csv',
      'doc': 'application/msword',
      'dll': 'application/octet-stream',
      'eot': 'application/vnd.ms-fontobject',
      'epub': 'application/epub+zip',
      'gif': 'image/gif',
      'htm': 'text/html',
      'html': 'text/html',
      'ico': 'image/x-icon',
      'ics': 'text/calendar',
      'jar': 'application/java-archive',
      'jpeg': 'image/jpeg',
      'jpg': 'image/jpeg',
      'js': 'application/javascript',
      'json': 'application/json',
      'mid': 'audio/midi',
      'midi': 'audio/midi',
      'mp2': 'audio/mpeg',
      'mp3': 'audio/mpeg',
      'mp4': 'video/mp4',
      'mpa': 'video/mpeg',
      'mpe': 'video/mpeg',
      'mpeg': 'video/mpeg',
      'mpkg': 'application/vnd.apple.installer+xml',
      'odp': 'application/vnd.oasis.opendocument.presentation',
      'ods': 'application/vnd.oasis.opendocument.spreadsheet',
      'odt': 'application/vnd.oasis.opendocument.text',
      'oga': 'audio/ogg',
      'ogv': 'video/ogg',
      'ogx': 'application/ogg',
      'otf': 'font/otf',
      'png': 'image/png',
      'pdf': 'application/pdf',
      'ppt': 'application/vnd.ms-powerpoint',
      'rar': 'application/x-rar-compressed',
      'rtf': 'application/rtf',
      'sh': 'application/x-sh',
      'svg': 'image/svg+xml',
      'swf': 'application/x-shockwave-flash',
      'tar': 'application/x-tar',
      'tif': 'image/tiff',
      'tiff': 'image/tiff',
      'ts': 'application/typescript',
      'ttf': 'font/ttf',
      'txt': 'text/plain',
      'vsd': 'application/vnd.visio',
      'wav': 'audio/x-wav',
      'weba': 'audio/webm',
      'webm': 'video/webm',
      'webp': 'image/webp',
      'woff': 'font/woff',
      'woff2': 'font/woff2',
      'xhtml': 'application/xhtml+xml',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.ms-excel',
      'xlsx_OLD': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'xml': 'application/xml',
      'xul': 'application/vnd.mozilla.xul+xml',
      'zip': 'application/zip',
      '3gp': 'video/3gpp',
      '3gp_DOES_NOT_CONTAIN_VIDEO': 'audio/3gpp',
      '3gp2': 'video/3gpp2',
      '3gp2_DOES_NOT_CONTAIN_VIDEO': 'audio/3gpp2',
      '7z': 'application/x-7z-compressed'
    };

    if (listMIME[extension]) {
      return listMIME[extension];
    } else {
      return 'application/octet-stream';
    }
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  uniqueObect(data, key) {
    const arrayUniqueByKey = data.reduce(
      (accumulator, current) => {
        if (!accumulator.some(x => x[key] === current[key])) {
          accumulator.push(current)
        }
        return accumulator;
      }, []
    );
    return arrayUniqueByKey;
  }

  changeFlavicon() {
    let titleNav = 'Ecorec';
    const site = this.local.getObject('siteUser');
    const societe = this.local.getObject('paramSociete');
    if (site && societe) {
      // titleNav = `${societe.nom || ''} : ${site.nom || ''}`;
      titleNav = `${site.nom || ''}`;
    }
    document.title = titleNav || '';
  }

  hexToRgbA(hex, alpha) {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + alpha + ')';
    }

    throw new Error('Bad Hex');
  }

  reformeNomClient(n) {
    if (n) {
      return n.replace('/', '_slash_');
    }

    return n;
  }

  getChantierRDV(id) {
    return this.getEcoportail(`${this.reformeNomClient(this.user['nom'])}/site/get/leger/${id}`);
  }

  getPoidsAvecDSD() {
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 21
        },
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.user[0]
        }
      }
    };

    return this.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

  getListSite(login, isHolding) {
    this.post('', {
      param: {
        'servlet': 'DBGetListSiteUser',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'NOM_UTILISATEUR': login,
          'IS_HOLDING': {
            'typeParam': 'boolean',
            'valeur': isHolding ? true : false
          }
        }
      }
    }).then(datas => {
      if (datas.data) {
        const listeSite = datas.data[0] || [];
        this.local.setObject('listeSite', listeSite);
      }
    }).catch(error => console.log(error));
  }

  getCodeBlocage(codeBlocage) {
    let code = '';
    switch (codeBlocage) {
      case 3:
        code = 'Bloqu\u00e9';
        break;
      case 4:
        code = 'Contentieux';
        break;
      case 5:
        code = 'RJ';
        break;
      case 6:
        code = 'Injonction';
        break;
      case 9:
        code = 'Retard des reglements';
        break;
      case 10:
        code = 'Litige';
        break;
      default:
        code = '';
        break;
    }

    return code;
  }

  // amélioration à faire
  // searchEcoloc(data) {
  //   return this.searchEcolocService(data);
  // }

  obligatoireSSO(notLoad?, appeldepuisCommon?) {
    let listUrl = [];

    if (this.local.getObject('stylePageEcoportail')) {
      const stylePageEcoportail = this.local.getObject('stylePageEcoportail') || {};
      listUrl = stylePageEcoportail.listeUrlEcoPortailSSO && stylePageEcoportail.listeUrlEcoPortailSSO.length ?
        stylePageEcoportail.listeUrlEcoPortailSSO : listUrl;
    }
    const current = window.location.href;
    const filterListe = listUrl.filter(url => current.includes(url.url));

    if (filterListe && filterListe.length) {
      this.lemonLDAPPortail = true;
      this.lemonLDAPObjet = filterListe[0];
      if (!notLoad) {
        this.router.navigateByUrl('/ecoportail/login');
      }
    }
  }

  obligatoireCodeClient(notLoad?, appeldepuisCommon?) {
    let listUrlCode = [];

    if (this.local.getObject('stylePageEcoportail')) {
      const stylePageEcoportail = this.local.getObject('stylePageEcoportail') || {};
      listUrlCode = stylePageEcoportail.listeUrlClientEcoPortail && stylePageEcoportail.listeUrlClientEcoPortail.length ?
        stylePageEcoportail.listeUrlClientEcoPortail : listUrlCode;
      this.testUrl(listUrlCode, notLoad, appeldepuisCommon || false);
    } else {
      this.testUrl(listUrlCode, notLoad, appeldepuisCommon || false);
    }
  }

  testUrl(listUrlCode, notLoad, appeldepuisCommon) {
    const current = window.location.href;
    const filterListe = listUrlCode.filter(url => current.includes(url.url));
    if (filterListe && filterListe.length) {
      const objUrl = filterListe[0];
      if (!this.local.get('codeExterneClient')) {
        this.local.set('codeExterneClient', objUrl.codeClient);
        if (appeldepuisCommon) {
          this.getLogoAndColorEcoportail(false, true);
        }
        if (!notLoad) {
          this.router.navigateByUrl('/ecoportail/login');
        }
      }
    } else {
      if (this.codeExterneClient && !this.local.get('codeExterneClient')) {
        this.local.set('codeExterneClient', this.codeExterneClient);
      }

      if (!this.lemonLDAPPortail) {
        this.obligatoireSSO(notLoad, appeldepuisCommon);
      }

    }
  }

  showSpinner() {
    const hasSpinner = this.local.get('hasSpinner') || false;
    return hasSpinner ? true : false;
  }

  parseHeure(row, model) {
    if (row[model] && row[model].length === 4) {
      if (!(row[model] || '').includes(':')) {
        row[model] = this.addStr(row[model], 2, ':');
      }
    }
  }

  addStr(str, index, stringToAdd) {
    return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
  }

  getPositionBtnFiltre() {
    const offset = $('#contFiltre').offset();
    return offset.left + 'px';
  }

  getWidthBtnFiltre() {
    const offset = $('#contFiltre').offset();
    return $('#contFiltre').width() + 'px';
  }

  getListFIP(idClt, isDD?, isSpinner?) {
    const user = this.local.getObject('userDetail') || {};
    const param = {
      'servlet': isDD ? 'DBGestionFipDD' : 'DBGestionFipDND',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': idClt || '0'
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': 0
        },
        'IS_USERMULTISITEFIP': {
          'typeParam': 'boolean',
          'valeur': user.isUserMultiSiteFIP || false
        }
      }
    };

    return this.post('', { param: param }, isSpinner || false).then(datas => {
      return datas.data;
    });
  }

  getDetailBon(bonId) {
    const param = {
      'servlet': 'DBGetDetailsBon',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'BON': {
          'id': bonId,
          'nomclass': 'Bon'
        },
        'LOAD_CHANTIER_CLIENT': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.user[2]
        }
      }
    };

    return this.post('', { param: param }).then(datas => {
      return datas.data[0];
    });
  }

  getTarifMinMaxArticleClient(listePrixMinMax, tarif, typeClient, checkMin) {
    listePrixMinMax = listePrixMinMax || [];
    tarif = tarif || 0;
    for (let i = 0; i < listePrixMinMax.length; i++) {
      const prixMinMaxTemp = listePrixMinMax[i];
      if (prixMinMaxTemp.typeClient && prixMinMaxTemp.typeClient.id === typeClient) {
        if (checkMin && tarif < prixMinMaxTemp.prixMin) {
          return prixMinMaxTemp.prixMin;
        }

        if (!checkMin && tarif > prixMinMaxTemp.prixMax) {
          return prixMinMaxTemp.prixMax;
        }

      }
    }

    return tarif;
  }

  exportXLS(index0) {
    const param = {
      'servlet': 'DBParametreXLS',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': [
        index0,
        '' + this.user[0],
        '' + this.user[2]
      ]
    };

    return this.post('', { param: param }, true).then(datas => {
      if (this.verifySession(datas)) {
        if (datas.data && datas.data[0]) {
          this.openFile(datas.data[0]);
        }
      }
    });
  }

  versionImp(materiel) {
    const idMat = materiel.id || 0
    const param = {
      'servlet': 'DBRapportsgeneriques',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'TITRE': 'FicheCamion',
        'NOM_FICHIER': 'FicheCamion',
        'FORMAT': 'PDF',
        'CLEF_CAMION': idMat.toString()
      }
    };

    return this.post('', { param: param }, true).then(datas => {
      if (this.verifySession(datas)) {
        if (datas.data && datas.data[0] && datas.data[0] === "Recylog/tmp/SUCCESS") {
          const urlToOpen = "Recylog/tmp/FicheCamion_" + idMat + ".pdf"
          this.openFile(urlToOpen);
        }
      }
    });
  }

  exportHolding(index0) {

    const param = {
      'OPERATION': {
        'typeParam': 'int',
        'valeur': 20
      },
      'SOUS_OPERATION': {
        'typeParam': 'int',
        'valeur': 1
      },
      'NOMOBJET': index0
    };

    // const url = this.parseUrlHolding('http://62.210.181.76:8186');
    return this.DBGestionParamHoldingAngular(param, false, true).then(datas => {
      if (this.verifySession(datas)) {
        if (datas.data && datas.data[0]) {
          this.openFile(datas.data[0], false, true);
        }
      }
    });
  }


  exportXLSContenant(index0) {
    const param = {
      'servlet': 'DBParametreXLS',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp',
      'data': [
        index0,
        '' + this.user[0],
        '' + this.user[2],
        {
          'typeParam': 'int',
          'valeur': 0
        },
        {
          'typeParam': 'int',
          'valeur': 0
        },
        {
          'typeParam': 'int',
          'valeur': 0
        },
        {
          'typeParam': 'boolean',
          'valeur': false
        },
        {
          'typeParam': 'boolean',
          'valeur': false
        },
        {
          'typeParam': 'boolean',
          'valeur': false
        }
      ]
    };
    return this.post('', { param: param }, true).then(datas => {
      if (this.verifySession(datas)) {
        if (datas.data && datas.data[0]) {
          this.openFile(datas.data[0]);
        }
      }
    });
  }

  capitalizeFirstLetter(s) {
    if (s && s.length) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    } else {
      return '';
    }
  }

  checkExtFichierImg(f) {
    if (f) {
      const filename = f.toLowerCase();
      let extFichierImgTab = this.extFichierImg.split(', ');
      const extensions = extFichierImgTab.filter(ext => filename.endsWith(ext));
      return extensions.length > 0;
    } else {
      return true;
    }
  }

  checkExtFichierImgEtTexte(f) {
    if (f) {
      const filename = f.toLowerCase();
      let extFichierImgEtTexteTab = this.extFichierImgEtTexte.split(', ');
      const extensions = extFichierImgEtTexteTab.filter(ext => filename.endsWith(ext));
      return extensions.length > 0;
    } else {
      return true;
    }
  }

  checkExtFichierImgAvecListe(f, extFichierImg) {
    if (f) {
      const filename = f.toLowerCase();
      let extFichierImgTab = extFichierImg.split(', ');
      const extensions = extFichierImgTab.filter(ext => filename.endsWith(ext));
      return extensions.length > 0;
    } else {
      return true;
    }
  }

  checkExtFichierImgEtTexteAvecListe(f, extFichierImgEtTexte) {
    if (f) {
      const filename = f.toLowerCase();
      let extFichierImgEtTexteTab = extFichierImgEtTexte.split(', ');
      const extensions = extFichierImgEtTexteTab.filter(ext => filename.endsWith(ext));
      return extensions.length > 0;
    } else {
      return true;
    }
  }

  isSiteSygetrack(isEcoloc?) {
    const site = this.local.getObject('siteUser');
    const societe = this.local.getObject('paramSociete')
    return societe['isSygetrack'] && (isEcoloc ? site['isGPS'] : site['isGPSEcobennes']);
  }

  isCLS() {
    const societe = this.local.getObject('paramSociete')
    return societe['CLS'];
  }

  trackById(index: number, item) {
    return item.id
  }

  socketPlanningEcobennes() {
    let url = '';
    const ctrl = this;
    const RemoveLastDirectoryPartOf = function (the_url) {
      const the_arr = the_url.split('/');
      the_arr.pop();
      return (the_arr.join('/'));
    }
    let base_url = document.getElementsByTagName('base')[0].href;
    if (environment.production) {
      base_url = environment.base_url;
      base_url = base_url.replace(/^http:/, 'ws:');
      base_url = base_url.replace(/^https:/, 'wss:');
      url = `${base_url}//EcorecServerAngular/planning/${this.user[0]}/${this.user[2]}`;
    } else {
      base_url = environment.base_url;
      base_url = 'http://192.168.2.202:8081';
      base_url = base_url.replace(/^http:/, 'ws:');
      base_url = base_url.replace(/^https:/, 'wss:');
      url = `${base_url}/EcorecServerAngular/planning/${this.user[0]}/${this.user[2]}`;
    }



    console.log('Socket URL Ecobennes', url);
    this.websocketPlaning = new WebSocket(url);
    this.websocketPlaning.onopen = function (evt) {
      console.log('>> Log socket open ok');
      ctrl.envoyerMsgSocket('CHECK');

    };

    this.websocketPlaning.onmessage = function (evt) {
      console.log('>> Log socket planning | On messageAfter check');
      ctrl.callBackAfterFirstMsg(evt);
    };

    this.websocketPlaning.onclose = function (evt) {
      console.log('>> Log socket planning | WebSocket déconnecté');
    };

    this.websocketPlaning.onerror = function (evt) {
      console.log('>> Log socket planning | WebSocket erreur : ');
      console.log(evt);
    };
  }

  callBackAfterFirstMsg(evt) {
    console.log('message rgthgtyh', evt);
    this.firstCallLoadPlanning.next(evt);
  }

  closeWebSocketPlanning() {
    if (!this.userDetail['adminKerlog']) {
      if (this.websocketPlaning) {
        this.planningInUse = false;
        this.websocketPlaning.close();
      }
    }
  }

  envoyerMsgSocket(msg) {
    const obj = {
      'user': this.user[0],
      'contenu': msg
    }
    if (!this.userDetail['adminKerlog']) {
      if (this.websocketPlaning) {
        this.websocketPlaning.send(JSON.stringify(obj));
      }
    }

  }

  getTimestamp() {
    return Math.round(+new Date() / 1000);
  }

  getDifference(array1, array2) {
    const arr1 = [], arr2 = [];
    array1.forEach(element => {
      arr1.push(element.id || 0)
    });
    array2.forEach(element => {
      arr2.push(element.id || 0)
    });
    console.log(arr1.join(','), arr2.join(','))
    return arr1.join(',') === arr2.join(',') ? false : true;
  }

  eltCorrespond(searchthis, elt) {
    const spliteSearch = searchthis.split('%');
    let regex;

    const matchPercent = (elt || '').search(new RegExp('%', 'gi'));
    if (matchPercent) {
      if (searchthis.startsWith('%')) {
        if (spliteSearch.length) {
          const recherche = ((spliteSearch[1] || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
          regex = new RegExp(recherche, 'gi');

          const event = ((elt || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
          return event.search(regex) >= 0;
        }
      } else {
        const last = searchthis.substr(searchthis.length - 1);
        const search = (searchthis).replace('%', '');
        if (last === '%') {
          const elem = (elt || '').toLocaleLowerCase();
          const recherche = ((elem || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
          const event = ((search || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
          return recherche.startsWith(event.toLocaleLowerCase());
        } else {
          const recherche = ((search || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
          const event = ((elt || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
          regex = new RegExp(recherche, 'gi');
          return event.search(regex) >= 0;
        }
      }
    } else {
      const recherche = ((searchthis || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
      const event = ((elt || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
      regex = new RegExp(recherche, 'gi');
      return event.search(regex) >= 0;
    }
  }

  formatDateSaisiManuel(date, objetCont, element) {
    const ctrl = this;
    let model;
    if (date && typeof date === 'string') {
      const DDMMYYYY = date.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-\.](0?[1-9]|1[012])[\/\-\.]\d{4}$/) ? true : false;
      if (DDMMYYYY) {
        model = moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY');
        if (model) {
          objetCont[element] = model;
        }
      } else {
        if (date && date.length === 6) {
          if (!date.includes('/') && moment(date, 'DDMMYY').isValid()) {
            model = moment(date, 'DDMMYY').format('DD/MM/YYYY');
            console.log(model, moment(date, 'DDMMYY').format('DD/MM/YYYY'));
            if (model) {
              objetCont[element] = model;
            }
          }
        } else {
          if (date && date.length === 8) {
            if (!date.includes('/') && moment(date, 'DDMMYYYY').isValid()) {
              model = moment(date, 'DDMMYYYY').format('DD/MM/YYYY');
              console.log(model, moment(date, 'DDMMYYYY').format('DD/MM/YYYY'))
              if (model) {
                objetCont[element] = model;
              }
            } else if (moment(date, 'DD/MM/YY').isValid()) {
              model = moment(date, 'DD/MM/YY').format('DD/MM/YYYY');
              console.log(model, moment(date, 'DD/MM/YY').format('DD/MM/YYYY'))
              if (model) {
                objetCont[element] = model;
              }
            }
          }
        }
      }
    } else {
      if (typeof date === 'object') {
        model = moment(date).format('DD/MM/YYYY');
        if (model) {
          objetCont[element] = model;
        }
      }
    }

    if (model === null) {
      objetCont[element] = '';
    }
  }

  appelComboK3Fct(ID_REQUETE, requette?, autreParam?) {
    let param: any = {
      'servlet': 'DBGetListComboK3',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'leger': 'true',
      'data': {
        'ID_REQUETE': {
          'typeParam': 'int',
          'valeur': ID_REQUETE
        },
        'CRITERE': '' + (requette || '')
      }
      // [
      //   index0 || 'DBGetListComboK3',
      //   requette
      // ]
    };
    if (typeof ID_REQUETE !== 'number') {
      const param2 = {
        'servlet': 'DBGetListComboK3',
        'module': 'Recylog',
        'type': 'tableau',
        'compression': 'false',
        'data': [
          'DBGetListComboK3',
          ID_REQUETE
        ]
      };
      param = param2;
    } else {
      if (autreParam && autreParam.length) {
        autreParam.forEach(element => {
          param['data'][element.nom] = element.valeur
        });
      }
    }



    return this.post('', { param: param }).then(datas => {
      if (this.verifySession(datas)) {
        return datas;
      } else {
        return { data: [] };
      }
    });
  }

  setVisibility(element, show) {
    setTimeout(() => {
      $(element).focus();
    }, 2);
  }

  /**
   * Obtient l'URL du Portail à partir de l'URL courant
   */
  getUrlPortail() {
    if (window
      && "location" in window
      && "protocol" in window.location
      && "pathname" in window.location
      && "host" in window.location) {
      let base = window.location.protocol + "//" + window.location.host + window.location.pathname;
      console.log(base.replace('/Ecorec/', '/Portail/'));

      if (environment.production) {
        base = base.replace('/Ecorec/', '/Portail/');
      } else {
      }

      return base + "#/ecoportail";
    }

    return null;
  }

  existeChampSuppClient(detail) {
    const listChampSupp = this.getType('typeChampsupp') || [];
    detail.ChampsClientSupp = detail.ChampsClientSupp || [];
    listChampSupp.forEach(elt => {
      detail.ChampsClientSupp.forEach(champ => {
        if (champ.nomChamp === elt.nom) {
          elt.actif = true;
          elt.valeur = champ.valeur;
        }
      });
    });

    return listChampSupp.filter(elt => elt.actif) || [];
  }

  ecrireLogSupplementaire(logJson) {
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 31
        },
        'LOG_ANGULAR': logJson
      }
    };

    return this.post('', { param: param });
  }

  getListParamEcranEcorec(ECRAN_ECOREC) {
    const societe = this.local.getObject('paramSociete') || {};
    const param = {
      'servlet': 'DBGestionParamEcranEcorec',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'ECRAN_ECOREC': {
          'typeParam': 'int',
          'valeur': ECRAN_ECOREC
        }
      }
    };

    if (societe.clientCollectivite) {
      return this.post('', { param: param }).then(datas => {
        if (this.verifySession(datas)) {
          if (datas.data.length) {
            datas.data = datas.data || [];
            datas.data.forEach(elt => {
              elt.visible = elt.visible || false;
            })
            this.parametrageEcran[ECRAN_ECOREC] = datas.data;
          }
        }
      });
    } else {
      this.parametrageEcran[ECRAN_ECOREC] = [];
    }

  }

  isTimeValid(time) {
    const timeFormat = 'HH:mm:ss';
    const parsedTime = moment(time, timeFormat, true);
    return parsedTime.isValid();
  }

  isAnneeValide(annee: number): boolean {
    const date = moment(`${annee}-01-01`, 'YYYY-MM-DD', true);
    return date.isValid();
  }


  scroolTop(id?) {
    if (id) {
      setTimeout(function () { $("'.'" + id + ".datatable-body'").scrollTop(0); }, 1);
    } else {
      setTimeout(function () { $('.cubage .datatable-body').scrollTop(0); }, 1);
    }
  }

  DBGestionPageAdmin(parametre, isSpinner?, ajoutPath?, postSansErreur?) {
    const user = this.local.getObject('userDetail') || {};
    const paramData = {
      'USER': {
        'typeParam': 'int',
        'valeur': user.id || 0
      },
      'OPERATION': {
        'typeParam': 'int',
        'valeur': this.fctAdminSelected['id'] || 0
      },
    }



    const allParam = { ...paramData, ...(parametre || {}) }
    const param = {
      'servlet': 'DBGestionPageAdmin',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': allParam
    };

    if (ajoutPath) {
      param['pathImpression'] = ajoutPath;
    }

    if (!postSansErreur) {
      return this.post('', { param: param }, isSpinner || false);
    } else {
      return this.postSansErreur('', { param: param }, isSpinner || false);
    }


  }


  DBGestionPageAdminKerlog(parametre, isSpinner?,forcerSerialisation?) {
    const user = this.local.getObject('userDetail') || {};
    const paramData = {
      'USER': {
        'typeParam': 'int',
        'valeur': user.id || 0
      },
      'OPERATION': {
        'typeParam': 'int',
        'valeur': this.fctAdminKerlogSelected['id'] || 0
      },
    }

    const allParam = { ...paramData, ...(parametre || {}) }
    const param = {
      'servlet': 'DBGestionPageAdminKerlog',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': allParam
    };

    if(forcerSerialisation){
      param["forcerSerialisation"]="true";
      param["leger"]="true";
    }

    return this.post('', { param: param }, isSpinner || false);

  }


  filterCarracterEmail(event: any) {
    const forbiddenChars = [';', '/', ' ']; // [';', '/', '+', ' ']
    if (forbiddenChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  validatePatternMail(email) {
    var regex = /^[^@]+(\.[^@]+)*@[^@]+(\.[^@]+)+(?:,[^@]+(\.[^@]+)*@[^@]+(\.[^@]+)+)*$/;
    var emailList = email ? email.split(',') : [];
    for (var i = 0; i < emailList.length; i++) {
      if (!regex.test(emailList[i])) {
        return false;
      }
    }
    return true;
  }

  getCodeBlocageClient(Client, clefsite) {
    const prop = this.getProprieteClientParSite(Client, clefsite);
    if (prop) {
      return prop['codeBlocage'] || 0;
    }

    return Client['codeBlocage'] || 0;
  }

  getProprieteClientParSite(Client, clefSite) {
    let p;


    if (!Client.listeProprietesParSite) {
      return null;
    }


    Client.listeProprietesParSite.forEach(prop => {
      if (prop.site && prop.site.id && prop.site.id === clefSite) {
        p = prop;
      }
    });

    return p;
  }

  getListPeriode() {
    const param = {
      'servlet': 'DBGestionPeriode',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
      }
    };

    // if (this.elementPeriodePlanningEcobennes && !this.elementPeriodePlanningEcobennes['existe']) {
    return this.post('', { param: param }).then(datas => {
      if (datas.data != null) {
        this.periodeLst = datas.data;
        const listPeriode = [];
        this.elementPeriodePlanningEcobennes.listePeriode = [{
          id: 0,
          libelleObjetEntite: 'Tous'
        }];
        const societe = this.local.getObject('paramSociete') || {};
        const periodeParSite = societe.periodeParSite || false;
        if (periodeParSite) {
          this.periodeLst.forEach(elt => {
            if (elt.site && elt.site.id === parseInt(this.user[2], 10)) {
              listPeriode.push(elt);
              this.elementPeriodePlanningEcobennes.listePeriode.push(elt);
            }
          });

          console.log(listPeriode);

          if (listPeriode.length > 1) {
            this.elementPeriodePlanningEcobennes.gererPeriod = true;
            if (listPeriode[0]) {
              this.elementPeriodePlanningEcobennes.periode1 = listPeriode[0].id || 1;
              this.elementPeriodePlanningEcobennes.objPeriode1 = listPeriode[0] || {};
            } else {
              this.elementPeriodePlanningEcobennes.periode1 = 1;
              this.elementPeriodePlanningEcobennes.objPeriode1 = {};
            }

            if (listPeriode[1]) {
              this.elementPeriodePlanningEcobennes.periode2 = listPeriode[1].id || 0;
              this.elementPeriodePlanningEcobennes.objPeriode2 = listPeriode[1] || {};
            }
            if (listPeriode[2]) {
              this.elementPeriodePlanningEcobennes.periode3 = listPeriode[2].id || 0;
              this.elementPeriodePlanningEcobennes.objPeriode3 = listPeriode[2] || {};
            }
          } else {
            this.elementPeriodePlanningEcobennes.gererPeriod = false;

            if (listPeriode.length === 1) {
              this.elementPeriodePlanningEcobennes.periode1 = listPeriode[0].id || 1;
              this.elementPeriodePlanningEcobennes.objPeriode1 = listPeriode[0] || {};
            } else {
              this.elementPeriodePlanningEcobennes.periode1 = 1;
              this.elementPeriodePlanningEcobennes.objPeriode1 = {};
            }
          }

        } else {
          this.periodeLst.forEach(elt => {
            this.elementPeriodePlanningEcobennes.listePeriode.push(elt);
          });

          if (this.periodeLst.length > 1) {
            this.elementPeriodePlanningEcobennes.gererPeriod = true;
            if (this.periodeLst[0]) {
              this.elementPeriodePlanningEcobennes.periode1 = this.periodeLst[0].id || 1;
              this.elementPeriodePlanningEcobennes.objPeriode1 = this.periodeLst[0] || {};
            } else {
              this.elementPeriodePlanningEcobennes.periode1 = 1;
              this.elementPeriodePlanningEcobennes.objPeriode1 = {};
            }

            if (this.periodeLst[1]) {
              this.elementPeriodePlanningEcobennes.periode2 = this.periodeLst[1].id || 0;
              this.elementPeriodePlanningEcobennes.objPeriode2 = this.periodeLst[1] || {};
            }
            if (this.periodeLst[2]) {
              this.elementPeriodePlanningEcobennes.periode3 = this.periodeLst[2].id || 0;
              this.elementPeriodePlanningEcobennes.objPeriode3 = this.periodeLst[2] || {};
            }
          } else {
            this.elementPeriodePlanningEcobennes.gererPeriod = false;
            if (listPeriode.length === 1) {
              this.elementPeriodePlanningEcobennes.periode1 = this.periodeLst[0].id || 1;
              this.elementPeriodePlanningEcobennes.objPeriode1 = this.periodeLst[0] || {};
            } else {
              this.elementPeriodePlanningEcobennes.periode1 = 1;
              this.elementPeriodePlanningEcobennes.objPeriode1 = {};
            }
          }
        }

        this.elementPeriodePlanningEcobennes.periodeprs = this.elementPeriodePlanningEcobennes.listePeriode[0];
        this.elementPeriodePlanningEcobennes.periodeprsbon = this.elementPeriodePlanningEcobennes.listePeriode[0];
        this.elementPeriodePlanningEcobennes.periodeprsbsdd = this.elementPeriodePlanningEcobennes.listePeriode[0];
        this.elementPeriodePlanningEcobennes.periodeprsadr = this.elementPeriodePlanningEcobennes.listePeriode[0];

        // this.elementPeriodePlanningEcobennes['existe'] = true;
      }
    });
    // }

  }

  getEncoursClient(client) {
    const env = environment;
    const societe = this.local.getObject('paramSociete') || {};
    const param = {
      'servlet': 'DBGetEncoursClient',
      'module': 'Ecofact',
      'type': 'liste',
      'data': ['' + (client.id || 0)]
    };

    if (societe['isAfficheEncours'] && env.moduleEcofact && this.isEcofact && !this.isPrestation) {
      return this.post('', { param: param }).then(datas => {

        const encours = Number(datas.data);

        client.afficheEncours = `${this.toFixed(encours || 0)}${societe.devise ? ' ' + (societe.devise || '') : ''}`;
        if (client['id'] > 0 && societe['isGestionPaiement'] && encours > ((client['encoursMax'] * 90) / 100)) {
          client.afficheEncoursRouge = true;
        } else {
          client.afficheEncoursRouge = false;
        }
        return datas.data;
      });
    }

  }

  getRssFlux(url) {
    return this.getEcoportail(`${this.reformeNomClient(this.user['nom'])}/society/get/rss?url=${encodeURIComponent(url)}`).then(datas => {
      const rss = datas && datas.length && datas[0] ? datas[0].rss : {};
      const data = rss['channel'] || {};
      data.item = data.item || [];
      data.item.forEach(elt => {
        elt.content = elt['content:encoded'];
        if (!elt.content) {
          elt.content = elt.description;
        }
        elt.pubDate = moment(elt.pubDate).format('YYYY-MM-DD HH:mm:ss');
        if (elt['media:content']) {
          elt.enclosure = Object.assign({}, elt['media:content']);
          elt.enclosure.link = elt.enclosure.url;
        } else {
          elt.enclosure = Object.assign({}, (data.image || {}));
          elt.enclosure.link = elt.enclosure.url;
        }
      })
      const objet = {
        items: data.item || [],
        feed: {
          image: data.image ? data.image.url || '' : ''
        }
      };
      return objet;
    });
  }

  closeDropdown(keyNotClose?) {
    for (let key in this.dropdownObject) {
      if (!keyNotClose && this.dropdownObject[key]) {
        this.dropdownObject[key].hide();
        this.dropdownObject[key].isOpen = false;
      }
      if (keyNotClose && this.dropdownObject[key] && keyNotClose !== parseInt(key, 10)) {
        this.dropdownObject[key].hide();
        this.dropdownObject[key].isOpen = false;
      }
    }
  }  


  triggerMajLieu(param:boolean = false) {
    this.majLieuSource.next(param);
  }
}
